(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  function initAnnouncement(bar) {
    if (bar.dataset.bound) return;
    bar.dataset.bound = '1';

    var STORAGE_KEY = 'nerdio_annc_dismissed';
    var dismissable = bar.dataset.dismissable === 'true';
    var days = parseInt(bar.dataset.dismissDays, 10) || 7;

    if (dismissable) {
      try {
        var ts = parseInt(localStorage.getItem(STORAGE_KEY), 10);
        if (ts && (Date.now() - ts) < days * 86400000) {
          bar.hidden = true;
          return;
        }
      } catch (e) {}
    }

    var msgs = bar.querySelectorAll('.annc__msg');
    var prev = bar.querySelector('[data-annc-dir="prev"]');
    var next = bar.querySelector('[data-annc-dir="next"]');
    var pauseBtn = bar.querySelector('[data-annc-pause]');
    var iconPause = bar.querySelector('.annc__icon-pause');
    var iconPlay = bar.querySelector('.annc__icon-play');
    var closeBtn = bar.querySelector('[data-annc-close]');
    var speed = (parseInt(bar.dataset.speed, 10) || 5) * 1000;
    var autoplay = bar.dataset.autoplay !== 'false';
    var pauseOnHover = bar.dataset.pauseOnHover === 'true';
    var reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
    var i = 0;
    var paused = !autoplay || reduceMotion;
    var timer;

    function show(n) {
      if (msgs.length < 2) return;
      msgs[i].classList.remove('is-active');
      i = (n + msgs.length) % msgs.length;
      msgs[i].classList.add('is-active');
    }

    function tick() {
      clearInterval(timer);
      if (paused || msgs.length < 2) return;
      timer = setInterval(function() { show(i + 1); }, speed);
    }

    function setPaused(v) {
      paused = v;
      if (iconPause) iconPause.style.display = paused ? 'none' : '';
      if (iconPlay) iconPlay.style.display = paused ? '' : 'none';
      if (pauseBtn) {
        pauseBtn.setAttribute('aria-pressed', paused);
        pauseBtn.setAttribute('aria-label', paused ? 'Resume announcements' : 'Pause announcements');
      }
      tick();
    }

    if (prev) prev.addEventListener('click', function() { show(i - 1); tick(); });
    if (next) next.addEventListener('click', function() { show(i + 1); tick(); });
    if (pauseBtn) pauseBtn.addEventListener('click', function() { setPaused(!paused); });
    if (closeBtn) closeBtn.addEventListener('click', function() {
      bar.hidden = true;
      try { localStorage.setItem(STORAGE_KEY, Date.now().toString()); } catch (e) {}
    });

    if (pauseOnHover) {
      bar.addEventListener('mouseenter', function() { if (autoplay && !reduceMotion) { clearInterval(timer); } });
      bar.addEventListener('mouseleave', function() { if (!paused) { tick(); } });
    }

    // Countdown timers
    var countdowns = bar.querySelectorAll('[data-countdown]');
    function pad(n) { return n < 10 ? '0' + n : n; }
    function updateCountdowns() {
      var now = Date.now();
      countdowns.forEach(function(el) {
        var display = el.querySelector('[data-countdown-display]');
        if (!display) return;
        var end = new Date(el.dataset.countdown).getTime();
        if (isNaN(end)) { display.textContent = '—'; return; }
        var diff = end - now;
        if (diff <= 0) {
          if (el.dataset.expiredHide === 'true') { el.hidden = true; }
          else { display.textContent = 'Ended'; }
          return;
        }
        var d = Math.floor(diff / 86400000);
        var h = Math.floor((diff % 86400000) / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        display.textContent = (d > 0 ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s);
      });
    }
    if (countdowns.length) {
      updateCountdowns();
      setInterval(updateCountdowns, 1000);
    }

    setPaused(paused);
  }

  function bootAnnouncement() {
    document.querySelectorAll('.section-announcement .annc').forEach(initAnnouncement);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAnnouncement);
  } else {
    bootAnnouncement();
  }
  document.addEventListener('shopify:section:load', bootAnnouncement);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  // Drawer-internal behaviors: tabs, bottom sheets, note/discount/shipping forms.
  // Re-initializes on every SRA swap. Drawer open/close/ESC/focus-trap live in
  // <cart-drawer> (assets/cart.js) — independent of this section's innerHTML.
  (function () {
    function currency() {
      const drawer = document.querySelector('cart-drawer');
      return (drawer && drawer.dataset.currencySymbol) || '$';
    }
    function money(cents) { return currency() + (cents / 100).toFixed(2); }

    function initTabs(root) {
      const tabs = root.querySelectorAll('[data-cart-tab]');
      const panels = root.querySelectorAll('[data-cart-tab-panel]');
      if (!tabs.length) return;
      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          const target = tab.dataset.cartTab;
          tabs.forEach((t) => {
            const active = t === tab;
            t.classList.toggle('is-active', active);
            t.setAttribute('aria-selected', active ? 'true' : 'false');
          });
          panels.forEach((p) => {
            const show = p.dataset.cartTabPanel === target;
            p.classList.toggle('is-active', show);
            if (show) p.removeAttribute('hidden');
            else p.setAttribute('hidden', '');
          });
          // Recently-viewed is client-rendered from localStorage; populate on show.
          if (target === 'recent' && window.nerdioRenderRecent) window.nerdioRenderRecent();
        });
      });
    }

    function initSheets(root) {
      const backdrop = root.querySelector('[data-sheet-backdrop]');
      const sheets = root.querySelectorAll('[data-sheet]');
      if (!sheets.length) return { close: () => {} };

      function closeAll() {
        sheets.forEach((s) => {
          s.classList.remove('is-open');
          s.setAttribute('aria-hidden', 'true');
        });
        if (backdrop) backdrop.classList.remove('is-open');
      }
      function open(name) {
        closeAll();
        const sheet = root.querySelector('[data-sheet="' + name + '"]');
        if (!sheet) return;
        sheet.classList.add('is-open');
        sheet.setAttribute('aria-hidden', 'false');
        if (backdrop) backdrop.classList.add('is-open');
        const target = sheet.querySelector('textarea, input[type="text"], input[type="search"]');
        if (target) setTimeout(() => target.focus(), 300);
      }

      root.querySelectorAll('[data-sheet-open]').forEach((btn) =>
        btn.addEventListener('click', () => open(btn.dataset.sheetOpen))
      );
      root.querySelectorAll('[data-sheet-close]').forEach((btn) =>
        btn.addEventListener('click', closeAll)
      );
      if (backdrop) backdrop.addEventListener('click', closeAll);

      return { close: closeAll, open };
    }

    function initNoteForm(root, sheets) {
      const form = root.querySelector('[data-note-form]');
      if (!form) return;
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        const btn = form.querySelector('[data-apply]');
        const msg = form.querySelector('[data-sheet-msg]');
        const note = form.querySelector('textarea[name="note"]').value;
        btn.disabled = true;
        msg.textContent = '';
        msg.className = 'cart-drawer__sheet-msg';
        fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ note })
        })
          .then((r) => r.json())
          .then(() => {
            msg.textContent = 'Note saved.';
            msg.classList.add('is-success');
            setTimeout(sheets.close, 800);
          })
          .catch(() => {
            msg.textContent = "Couldn't save note.";
            msg.classList.add('is-error');
          })
          .finally(() => { btn.disabled = false; });
      });
    }

    function initDiscountForm(root) {
      const form = root.querySelector('[data-discount-form]');
      if (!form) return;
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        const code = form.querySelector('[data-discount-input]').value.trim();
        if (!code) return;
        // Shopify applies discount codes via a URL redirect to /discount/CODE.
        // We come back to the same page; body.cart-drawer-is-open is set by the
        // custom element on connect if session says 'reopen'.
        sessionStorage.setItem('cartDrawerReopen', '1');
        const back = window.location.pathname + window.location.search;
        window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(back);
      });
    }

    function initShippingForm(root) {
      const form = root.querySelector('[data-shipping-form]');
      if (!form) return;
      const countrySel = form.querySelector('[data-ship-country]');
      const provinceInput = form.querySelector('[data-ship-province]');
      const provinceWrap = form.querySelector('[data-province-wrap]');
      const zipInput = form.querySelector('[data-ship-zip]');
      const countryCombo = form.querySelector('[data-combo="country"]');
      const provinceCombo = form.querySelector('[data-combo="province"]');
      const STORAGE_KEY = 'nerdio:ship-estimate';

      function loadSaved() {
        try { const raw = localStorage.getItem(STORAGE_KEY); return raw ? JSON.parse(raw) : null; }
        catch (e) { return null; }
      }
      function saveAddr(country, province, zip) {
        try { localStorage.setItem(STORAGE_KEY, JSON.stringify({ country, province, zip })); }
        catch (e) {}
      }

      function initCombo(combo, options, onSelect, placeholder) {
        const btn = combo.querySelector('[data-combo-btn]');
        const pop = combo.querySelector('[data-combo-pop]');
        const search = combo.querySelector('[data-combo-search]');
        const list = combo.querySelector('[data-combo-list]');
        const valueEl = combo.querySelector('[data-combo-value]');

        function render(filter) {
          const f = (filter || '').toLowerCase().trim();
          list.innerHTML = '';
          let any = false;
          options.forEach((opt) => {
            if (f && opt.label.toLowerCase().indexOf(f) === -1) return;
            any = true;
            const li = document.createElement('li');
            li.setAttribute('role', 'option');
            li.setAttribute('data-value', opt.value);
            li.textContent = opt.label;
            if (combo.dataset.value === opt.value) li.setAttribute('aria-selected', 'true');
            li.addEventListener('click', () => { pick(opt); close(); });
            list.appendChild(li);
          });
          if (!any) {
            const em = document.createElement('div');
            em.className = 'cart-drawer__combo-empty';
            em.textContent = 'No matches';
            list.appendChild(em);
          }
        }
        function pick(opt) {
          combo.dataset.value = opt.value;
          valueEl.textContent = opt.label;
          if (onSelect) onSelect(opt);
        }
        function open() {
          pop.removeAttribute('hidden');
          btn.setAttribute('aria-expanded', 'true');
          search.value = '';
          render('');
          setTimeout(() => search.focus(), 0);
        }
        function close() {
          pop.setAttribute('hidden', '');
          btn.setAttribute('aria-expanded', 'false');
        }
        btn.addEventListener('click', (e) => { e.stopPropagation(); pop.hasAttribute('hidden') ? open() : close(); });
        search.addEventListener('input', () => render(search.value));
        search.addEventListener('click', (e) => e.stopPropagation());
        document.addEventListener('click', (e) => { if (!combo.contains(e.target)) close(); });
        document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !pop.hasAttribute('hidden')) close(); });

        if (placeholder && !combo.dataset.value) valueEl.textContent = placeholder;
        return {
          setOptions(newOpts) { options = newOpts; render(''); },
          setValue(val) { const m = options.find((o) => o.value === val); if (m) pick(m); },
          reset(ph) { combo.dataset.value = ''; valueEl.textContent = ph || 'Select…'; }
        };
      }

      const countryOptions = Array.prototype.map.call(countrySel.options, (o) => ({
        value: o.value,
        label: o.textContent.trim(),
        provinces: o.getAttribute('data-provinces') || '[]',
      }));

      const countryCtl = initCombo(countryCombo, countryOptions, (opt) => {
        countrySel.value = opt.value;
        updateProvinces(opt, null);
      });
      const provinceCtl = initCombo(provinceCombo, [], (opt) => {
        provinceInput.value = opt.value;
      }, 'Select…');

      function updateProvinces(countryOpt, savedProvince) {
        let provinces = [];
        try { provinces = JSON.parse(countryOpt.provinces || '[]'); } catch (e) {}
        if (!provinces.length) {
          provinceWrap.setAttribute('hidden', '');
          provinceInput.value = '';
          provinceCtl.setOptions([]);
          provinceCtl.reset('Select…');
          return;
        }
        provinceCtl.setOptions(provinces.map((p) => ({ value: p[1], label: p[1] })));
        provinceWrap.removeAttribute('hidden');
        if (savedProvince) { provinceCtl.setValue(savedProvince); provinceInput.value = savedProvince; }
        else { provinceCtl.reset('Select…'); provinceInput.value = ''; }
      }

      // Prefer the shopper's localized country when it is one we ship to; otherwise the
      // first shipping-zone country.
      const preferredCountry = countrySel.dataset.defaultCountry || '';
      if (preferredCountry && countryOptions.some((o) => o.value === preferredCountry)) {
        countrySel.value = preferredCountry;
      }
      const defaultCountry = countryOptions.find((o) => o.value === countrySel.value) || countryOptions[0];
      if (defaultCountry) {
        countryCombo.dataset.value = defaultCountry.value;
        countryCombo.querySelector('[data-combo-value]').textContent = defaultCountry.label;
      }

      const saved = loadSaved();
      if (saved && saved.country) {
        const sc = countryOptions.find((o) => o.value === saved.country);
        if (sc) {
          countrySel.value = saved.country;
          countryCtl.setValue(saved.country);
          updateProvinces(sc, saved.province);
          if (saved.zip) zipInput.value = saved.zip;
        } else {
          updateProvinces(defaultCountry, null);
        }
      } else {
        updateProvinces(defaultCountry, null);
      }

      function pollRates(params, attempt) {
        attempt = attempt || 0;
        if (attempt > 10) return Promise.resolve(null);
        return fetch('/cart/async_shipping_rates.json?' + params.toString(), { credentials: 'same-origin' })
          .then((r) => r.json())
          .then((data) => {
            if (data.shipping_rates === null) {
              return new Promise((resolve) => setTimeout(() => resolve(pollRates(params, attempt + 1)), 500));
            }
            return data;
          });
      }

      form.addEventListener('submit', (e) => {
        e.preventDefault();
        const btn = form.querySelector('button[type="submit"]');
        const result = form.querySelector('[data-ship-result]');
        const country = (countrySel.value || '').trim();
        const province = !provinceWrap.hasAttribute('hidden') ? (provinceInput.value || '').trim() : '';
        const zip = zipInput.value.trim();

        if (!country || !zip) {
          result.removeAttribute('hidden');
          result.innerHTML = '<p class="cart-drawer__ship-error">Please select a country and enter a postal/ZIP code.</p>';
          return;
        }
        saveAddr(country, province, zip);
        btn.disabled = true;
        result.removeAttribute('hidden');
        result.innerHTML = '<p class="cart-drawer__ship-loading">Calculating…</p>';

        const params = new URLSearchParams();
        params.set('shipping_address[country]', country);
        if (province) params.set('shipping_address[province]', province);
        params.set('shipping_address[zip]', zip);

        fetch('/cart/prepare_shipping_rates.json?' + params.toString(), {
          method: 'POST', credentials: 'same-origin',
        })
          .then(() => pollRates(params))
          .then((data) => {
            btn.disabled = false;
            if (!data || !data.shipping_rates || data.shipping_rates.length === 0) {
              result.innerHTML = '<p class="cart-drawer__ship-error">No shipping rates available for this address.</p>';
              return;
            }
            let html = '<ul class="cart-drawer__ship-list">';
            data.shipping_rates.forEach((rate) => {
              const priceCents = Math.round(parseFloat(rate.price) * 100);
              const label = rate.presentment_name || rate.name;
              const eta = (rate.delivery_range && rate.delivery_range.length === 2)
                ? '<span class="cart-drawer__ship-eta">' + rate.delivery_range[0] + ' – ' + rate.delivery_range[1] + '</span>'
                : '';
              const priceText = priceCents === 0 ? 'Free' : money(priceCents);
              html += '<li><div class="cart-drawer__ship-row"><span class="cart-drawer__ship-label">' + label + eta + '</span><strong>' + priceText + '</strong></div></li>';
            });
            html += '</ul><p class="cart-drawer__ship-note">Final shipping and taxes calculated at checkout.</p>';
            result.innerHTML = html;
          })
          .catch(() => {
            btn.disabled = false;
            result.innerHTML = '<p class="cart-drawer__ship-error">Couldn\'t calculate rates. Check the address and try again.</p>';
          });
      });
    }

    function escapeAttr(s) {
      return String(s == null ? '' : s)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }

    function upsellMoney(cents, currency) {
      const c = parseInt(cents, 10) || 0;
      try {
        return (c / 100).toLocaleString(undefined, { style: 'currency', currency: currency });
      } catch (_) {
        return money(c); // fall back to the section's symbol+toFixed helper
      }
    }

    // Build one slide that mirrors snippets/cart-upsell-card.liquid (link-only card).
    function upsellSlide(p, currency) {
      const v = (p.variants && p.variants[0]) || {};
      const price = (typeof v.price === 'number') ? v.price : p.price;
      const cap = (typeof v.compare_at_price === 'number') ? v.compare_at_price : p.compare_at_price;
      const onSale = cap && cap > price;
      const savePct = onSale ? Math.round((cap - price) * 100 / cap) : 0;
      const available = p.available !== false;
      const imgSrc = p.featured_image
        ? (p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=240')
        : '';
      const img = imgSrc
        ? '<img class="cuc__img" loading="lazy" src="' + escapeAttr(imgSrc) + '" alt="' + escapeAttr(p.title) + '">'
        : '';
      let badge = '';
      if (onSale) badge = '<span class="cuc__badge">−' + savePct + '%</span>';
      else if (!available) badge = '<span class="cuc__badge cuc__badge--out">Sold out</span>';
      const was = onSale ? '<span class="cuc__price-was">' + upsellMoney(cap, currency) + '</span>' : '';
      return ''
        + '<div class="cart-upsell__slide">'
        +   '<a class="cuc' + (available ? '' : ' cuc--unavailable') + '" href="' + escapeAttr(p.url) + '" data-cuc data-handle="' + escapeAttr(p.handle) + '">'
        +     '<div class="cuc__media">' + badge + img + '</div>'
        +     '<div class="cuc__body">'
        +       '<span class="product-card-view">View item</span>'
        +       '<p class="cuc__title">' + escapeAttr(p.title) + '</p>'
        +       '<p class="cuc__price">'
        +         '<span class="cuc__price-now' + (onSale ? ' is-sale' : '') + '">' + upsellMoney(price, currency) + '</span>'
        +         was
        +       '</p>'
        +     '</div>'
        +   '</a>'
        + '</div>';
    }

    function initUpsell(root) {
      const wrap = root.querySelector('[data-upsell-carousel]');
      if (!wrap) return;
      const track = wrap.querySelector('[data-upsell-track]');
      if (!track) return;

      const hasFallback = track.children.length > 0;
      const affinity = wrap.dataset.upsellAffinity === '1';
      const baseId = parseInt(wrap.dataset.upsellBaseId, 10) || 0;

      // No affinity OR no base product → use whatever the server rendered.
      if (!affinity || !baseId) {
        if (hasFallback) initUpsellCarousel(root);
        else wrap.hidden = true;
        return;
      }

      const recUrl = wrap.dataset.upsellRecUrl || '/recommendations/products.json';
      const currency = wrap.dataset.upsellCurrency || 'USD';
      const cartIds = new Set((wrap.dataset.upsellCartIds || '').split(',').filter(Boolean).map(Number));
      const max = Math.min(parseInt(wrap.dataset.upsellMax, 10) || 6, 10);
      const intent = wrap.dataset.upsellIntent || 'complementary';
      // Over-fetch a little to survive dedupe; clamp to the API max of 10.
      const fetchLimit = Math.min(max + cartIds.size, 10);

      const fetchRecs = (which) =>
        fetch(recUrl + '?product_id=' + baseId + '&limit=' + fetchLimit + '&intent=' + which, { credentials: 'same-origin' })
          .then((r) => (r.ok ? r.json() : { products: [] }))
          .then((d) => (d && Array.isArray(d.products)) ? d.products : [])
          .catch(() => []);

      const dedupe = (list) => list.filter((p) => p && !cartIds.has(p.id)).slice(0, max);

      fetchRecs(intent)
        .then((list) => {
          const primary = dedupe(list);
          if (primary.length) return primary;
          // Tier 2: related (only if the primary intent wasn't already related).
          if (intent === 'related') return [];
          return fetchRecs('related').then(dedupe);
        })
        .then((recs) => {
          if (recs.length) {
            track.innerHTML = recs.map((p) => upsellSlide(p, currency)).join('');
            initUpsellCarousel(root);          // init ONCE, after the swap
          } else if (hasFallback) {
            initUpsellCarousel(root);          // keep server slides, init ONCE
          } else {
            wrap.hidden = true;                // affinity-only + nothing → hide
          }
        })
        .catch(() => { if (hasFallback) initUpsellCarousel(root); else wrap.hidden = true; });
    }

    function initUpsellCarousel(root) {
      const wrap = root.querySelector('[data-upsell-carousel]');
      if (!wrap) return;
      const track = wrap.querySelector('[data-upsell-track]');
      const slides = track ? Array.from(track.querySelectorAll('.cart-upsell__slide')) : [];
      const prevBtn = wrap.querySelector('[data-upsell-dir="prev"]');
      const nextBtn = wrap.querySelector('[data-upsell-dir="next"]');
      if (!track || !slides.length) return;

      let pos = 0, isDragging = false, dragStartX = 0, dragDX = 0, baseOffset = 0, suppressClick = false;
      const CLICK_THRESHOLD = 6;

      const maxScroll = () => {
        const last = slides[slides.length - 1];
        const firstOffset = slides[0].offsetLeft;
        const trackEnd = last.offsetLeft + last.offsetWidth;
        const viewportW = track.parentElement.clientWidth;
        return Math.max(0, trackEnd - viewportW - firstOffset);
      };
      const maxIndex = () => {
        const max = maxScroll();
        const firstOffset = slides[0].offsetLeft;
        for (let i = 0; i < slides.length; i++) {
          if ((slides[i].offsetLeft - firstOffset) >= max - 1) return i;
        }
        return slides.length - 1;
      };
      const clampPos = (n) => Math.max(0, Math.min(maxIndex(), n));
      const targetOffset = () => {
        const target = slides[pos];
        if (!target) return 0;
        const firstOffset = slides[0].offsetLeft;
        return Math.min(target.offsetLeft - firstOffset, maxScroll());
      };
      const updateNav = () => {
        if (!prevBtn || !nextBtn) return;
        const disableAll = maxScroll() <= 0;
        prevBtn.disabled = disableAll || pos <= 0;
        nextBtn.disabled = disableAll || pos >= maxIndex();
      };
      const setTransform = (animate) => {
        track.style.transition = animate === false ? 'none' : '';
        track.style.transform = `translateX(${-targetOffset()}px)`;
        updateNav();
      };
      const go = (dir) => { pos = clampPos(pos + dir); setTransform(true); };

      if (prevBtn) prevBtn.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); go(-1); });
      if (nextBtn) nextBtn.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); go(1); });

      // Two-phase drag detection so simple taps fall through to anchor clicks:
      //   pointerdown → "armed" only (no capture, no class)
      //   pointermove past threshold → "engaged" (capture pointer, add classes)
      let armed = false;
      let activePointerId = null;
      track.addEventListener('pointerdown', (e) => {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        if (e.target.closest('[data-upsell-dir]')) return;
        armed = true;
        isDragging = false;
        activePointerId = e.pointerId;
        dragStartX = e.clientX;
        dragDX = 0;
        baseOffset = targetOffset();
      });
      track.addEventListener('pointermove', (e) => {
        if (!armed) return;
        dragDX = e.clientX - dragStartX;
        if (!isDragging) {
          if (Math.abs(dragDX) <= CLICK_THRESHOLD) return;
          // Engage drag mode now that movement has actually occurred
          isDragging = true;
          track.style.transition = 'none';
          track.classList.add('is-dragging');
          track.classList.add('is-actually-dragging');
          try { track.setPointerCapture(activePointerId); } catch (_) {}
        }
        const proposed = baseOffset - dragDX;
        const max = maxScroll();
        let clamped;
        if (proposed < 0) clamped = proposed * 0.35;
        else if (proposed > max) clamped = max + (proposed - max) * 0.35;
        else clamped = proposed;
        track.style.transform = `translateX(${-clamped}px)`;
      });
      const endDrag = () => {
        if (!armed) return;
        armed = false;
        const wasDragging = isDragging;
        isDragging = false;
        activePointerId = null;
        if (!wasDragging) return; // pure tap — let click bubble naturally
        track.classList.remove('is-dragging');
        track.classList.remove('is-actually-dragging');
        track.style.transition = '';
        suppressClick = Math.abs(dragDX) > CLICK_THRESHOLD;
        const threshold = slides[pos].offsetWidth * 0.2;
        if (dragDX < -threshold) go(1);
        else if (dragDX > threshold) go(-1);
        else setTransform(true);
      };
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('pointerleave', endDrag);
      track.addEventListener('dragstart', (e) => e.preventDefault());
      track.addEventListener('click', (e) => {
        if (suppressClick) { e.preventDefault(); e.stopPropagation(); suppressClick = false; }
      }, true);

      const onResize = () => { pos = clampPos(pos); setTransform(false); };
      // Closed details have zero-size content. Measure after every expansion,
      // not only at initialization or when the drawer first opens.
      wrap.addEventListener('toggle', () => {
        if (wrap.open) requestAnimationFrame(onResize);
      });
      // Debounced resize
      let raf;
      window.addEventListener('resize', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(onResize);
      });

      setTransform(false);
      // Recalculate on first drawer open (layout isn't reliable off-screen).
      document.addEventListener('cart:open-drawer', () => {
        requestAnimationFrame(() => { pos = clampPos(pos); setTransform(false); });
      }, { once: true });
    }

    function initUpsellQuickAdd(root) {
      // Quick-add buttons inside upsell cards — intercept and use cartStore so
      // SRA refreshes the drawer (the just-added product drops out of the upsell).
      if (root._upsellBound) return;
      root._upsellBound = true;
      root.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-quick-add]');
        if (!btn || !btn.closest('[data-upsell-carousel]')) return;
        const variantId = parseInt(btn.dataset.variantId, 10);
        if (!variantId) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        const original = btn.innerHTML;
        btn.disabled = true;
        btn.innerHTML = 'Adding…';
        window.cartStore.add({ items: [{ id: variantId, quantity: 1 }], openDrawer: false })
          .catch(() => { btn.innerHTML = original; btn.disabled = false; });
      }, true);
    }

    // a11y: keep `inert` in lock-step with aria-hidden so the closed drawer's
    // links/buttons/inputs are truly unreachable (fixes aria-hidden-focus).
    // Open/close flips aria-hidden in assets/cart.js; we observe it here and
    // re-wire on every SRA swap (the root element is recreated on cart:updated).
    function syncInert(root) {
      if (root.getAttribute('aria-hidden') === 'false') root.removeAttribute('inert');
      else root.setAttribute('inert', '');
    }
    function watchInert(root) {
      syncInert(root);
      if (root._inertObserver) return;
      root._inertObserver = new MutationObserver(function () { syncInert(root); });
      root._inertObserver.observe(root, { attributes: true, attributeFilter: ['aria-hidden'] });
    }

    function initAll() {
      const root = document.getElementById('cart-drawer-root');
      if (!root) return;
      watchInert(root);
      initTabs(root);
      const sheets = initSheets(root);
      initNoteForm(root, sheets);
      initDiscountForm(root);
      initShippingForm(root);
      initUpsell(root);
      initUpsellQuickAdd(root);
      // Repopulate the Recently-viewed tab after SRA swaps the panel HTML.
      if (window.nerdioRenderRecent) window.nerdioRenderRecent();
    }

    initAll();
    // Re-init after Section Rendering API swaps the drawer innerHTML.
    document.addEventListener('cart:updated', initAll);
    // Note: discount-code reopen is handled by <cart-drawer> connectedCallback
    // in assets/cart.js — more reliable than section-script timing.
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-notification"]) return;
  try {
    
  // Cart notification toast. Listens to cart:item-added, clones the template,
  // populates it, adds to stack, auto-dismisses.
  (function () {
    class CartNotification extends HTMLElement {
      connectedCallback() {
        if (this._bound) return;
        this._bound = true;
        this.template = this.querySelector('[data-toast-template]');
        this.stack = this.querySelector('[data-toast-stack]');
        this.dismissMs = parseInt(this.dataset.dismissMs || '4000', 10);

        document.addEventListener('cart:item-added', (e) => this.showToast(e.detail));
      }

      showToast({ item, cart }) {
        if (!item) return;
        const node = this.template.content.firstElementChild.cloneNode(true);
        window.NerdioClone?.uniqueIds(node, 'cart-toast-' + Date.now());

        // Populate
        const img = node.querySelector('[data-toast-image]');
        const imgLink = node.querySelector('[data-toast-image-link]');
        const imgUrl = item.featured_image?.url || item.image || (cart && cart.items?.find((i) => i.key === item.key)?.image);
        if (imgUrl) {
          img.src = imgUrl.replace(/(\.[a-z]+)(\?.*)?$/i, '_180x$1$2');
          img.alt = item.product_title || item.title || '';
        } else {
          img.remove();
        }
        if (imgLink && item.url) imgLink.href = item.url;

        node.querySelector('[data-toast-title]').textContent = item.product_title || item.title || 'Item added';
        const variantEl = node.querySelector('[data-toast-variant]');
        if (item.variant_title && item.variant_title !== 'Default Title') {
          variantEl.textContent = item.variant_title;
        } else {
          variantEl.remove();
        }

        // Wire close + autodismiss
        const close = () => this.dismiss(node);
        node.querySelector('[data-toast-close]').addEventListener('click', close);

        let timer = setTimeout(close, this.dismissMs);
        node.addEventListener('mouseenter', () => clearTimeout(timer));
        node.addEventListener('mouseleave', () => { timer = setTimeout(close, this.dismissMs); });

        this.stack.appendChild(node);
        requestAnimationFrame(() => node.classList.add('is-in'));
      }

      dismiss(node) {
        if (!node.isConnected) return;
        node.classList.remove('is-in');
        node.classList.add('is-out');
        setTimeout(() => node.remove(), 250);
      }
    }

    if (!customElements.get('cart-notification')) {
      customElements.define('cart-notification', CartNotification);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collections"] && !Shopify.designMode) return;
  try {
    
  function initCollectionsList(root) {
    if (root.dataset.bound) return;
    root.dataset.bound = '1';

    // Curated-order index — captured from initial DOM order so the "Curated order"
    // sort restores the merchant's block_order after AZ/count sorts shuffle cards.
    Array.from(root.querySelectorAll('[data-card]')).forEach((card, i) => {
      card.dataset.order = String(i + 1);
    });

    // Build group filter chips dynamically from the rendered groups (theme blocks
    // are opaque to the section's Liquid, so we can't iterate section.blocks).
    const chipsNav = root.querySelector('[data-clp-chips]');
    if (chipsNav) {
      const groupEls = root.querySelectorAll('.clp__group[data-group-title]');
      if (groupEls.length > 1) {
        groupEls.forEach((g) => {
          const slug = g.dataset.group;
          const title = g.dataset.groupTitle || slug;
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'clp__chip';
          btn.dataset.filterGroup = slug;
          btn.textContent = title;
          chipsNav.appendChild(btn);
        });
        chipsNav.hidden = false;
      }
    }

    const cards   = Array.from(root.querySelectorAll('[data-card]'));
    const groups  = Array.from(root.querySelectorAll('[data-group]'));
    const searchEl   = root.querySelector('[data-clp-search]');
    const clearEl    = root.querySelector('[data-clp-clear]');
    const sortOpen   = root.querySelector('[data-clp-sort-open]');
    const sortLabel  = root.querySelector('[data-clp-sort-label]');
    const sortPop    = root.querySelector('[data-clp-sort-popover]');
    const sortClose  = root.querySelector('[data-clp-sort-close]');
    const sortItems  = Array.from(root.querySelectorAll('[data-clp-sort-value]'));
    const emptyEl    = root.querySelector('[data-clp-empty]');
    const chipEls    = Array.from(root.querySelectorAll('[data-filter-group]'));

    let state = { query: '', group: 'all', sort: 'order' };

    function apply() {
      const q = state.query.trim().toLowerCase();
      let visibleTotal = 0;

      // Filter cards
      cards.forEach((card) => {
        const groupEl = card.closest('[data-group]');
        const inGroup = state.group === 'all' || (groupEl && groupEl.dataset.group === state.group);
        const matches = q === '' || (card.dataset.search || '').indexOf(q) !== -1;
        const show = inGroup && matches;
        card.classList.toggle('is-hidden', !show);
        if (show) visibleTotal++;
      });

      // Hide groups with zero visible cards
      groups.forEach((group) => {
        const anyVisible = group.querySelectorAll('[data-card]:not(.is-hidden)').length > 0;
        group.classList.toggle('is-hidden', !anyVisible);
      });

      if (emptyEl) emptyEl.hidden = visibleTotal > 0;

      // Sort cards within each group
      groups.forEach((group) => {
        const grid = group.querySelector('.clp__grid');
        if (!grid) return;
        const cs = Array.from(grid.querySelectorAll('[data-card]'));
        cs.sort((a, b) => {
          switch (state.sort) {
            case 'az':         return a.dataset.title.localeCompare(b.dataset.title);
            case 'za':         return b.dataset.title.localeCompare(a.dataset.title);
            case 'count-desc': return parseInt(b.dataset.count, 10) - parseInt(a.dataset.count, 10);
            case 'count-asc':  return parseInt(a.dataset.count, 10) - parseInt(b.dataset.count, 10);
            default:           return parseInt(a.dataset.order, 10) - parseInt(b.dataset.order, 10);
          }
        });
        cs.forEach((el) => grid.appendChild(el));
      });
    }

    if (searchEl) {
      searchEl.addEventListener('input', () => {
        state.query = searchEl.value;
        if (clearEl) clearEl.hidden = state.query === '';
        apply();
      });
    }
    if (clearEl) {
      clearEl.addEventListener('click', () => {
        if (!searchEl) return;
        searchEl.value = '';
        state.query = '';
        clearEl.hidden = true;
        searchEl.focus();
        apply();
      });
    }
    function closeSort() {
      if (!sortPop) return;
      sortPop.classList.remove('is-open');
      sortPop.setAttribute('aria-hidden', 'true');
      if (sortOpen) sortOpen.setAttribute('aria-expanded', 'false');
    }
    function openSort() {
      if (!sortPop) return;
      sortPop.classList.add('is-open');
      sortPop.setAttribute('aria-hidden', 'false');
      if (sortOpen) sortOpen.setAttribute('aria-expanded', 'true');
    }
    if (sortOpen) {
      sortOpen.addEventListener('click', (e) => {
        e.stopPropagation();
        if (sortPop.classList.contains('is-open')) closeSort(); else openSort();
      });
    }
    if (sortClose) sortClose.addEventListener('click', closeSort);
    document.addEventListener('click', (e) => {
      if (!sortPop || !sortPop.classList.contains('is-open')) return;
      if (sortPop.contains(e.target) || (sortOpen && sortOpen.contains(e.target))) return;
      closeSort();
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeSort(); });
    sortItems.forEach((item) => {
      item.addEventListener('click', () => {
        state.sort = item.dataset.clpSortValue;
        sortItems.forEach((i) => {
          i.classList.toggle('is-active', i === item);
          const dot = i.querySelector('.clp__sort-active-dot');
          if (i === item && !dot) {
            const s = document.createElement('span');
            s.className = 'clp__sort-active-dot';
            i.appendChild(s);
          } else if (i !== item && dot) {
            dot.remove();
          }
        });
        if (sortLabel) sortLabel.textContent = item.dataset.clpSortName || item.textContent;
        closeSort();
        apply();
      });
    });
    chipEls.forEach((chip) => {
      chip.addEventListener('click', () => {
        const g = chip.dataset.filterGroup;
        state.group = g;
        chipEls.forEach((c) => c.classList.toggle('is-active', c === chip));
        // Scroll to group when specific group is selected (not "all")
        if (g !== 'all') {
          const target = root.querySelector('#group-' + g);
          if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        apply();
      });
    });

    apply();
  }

  function bootCollectionsList() {
    document.querySelectorAll('[data-clp]').forEach(initCollectionsList);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootCollectionsList);
  } else {
    bootCollectionsList();
  }
  document.addEventListener('shopify:section:load', bootCollectionsList);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  /* Shared: build a tab strip from a NodeList of [data-tab][data-tab-label]
     content elements. Returns the strip element + first key. The caller is
     responsible for inserting the strip into the DOM and setting the
     scope's data-has-tabs / data-active-tab attributes. */
  function buildTabStrip(opts) {
    var contents = Array.prototype.slice.call(opts.contents);
    var strip = document.createElement('div');
    strip.className = opts.stripClass;
    strip.setAttribute('role', 'tablist');
    contents.forEach(function(tc, i) {
      var tk = tc.getAttribute('data-tab');
      var tl = tc.getAttribute('data-tab-label') || tk;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = opts.btnClass + (i === 0 ? ' is-active' : '');
      btn.setAttribute('role', 'tab');
      btn.setAttribute('data-tab-target', tk);
      btn.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
      btn.textContent = tl;
      strip.appendChild(btn);
      if (i > 0) tc.classList.add('is-tab-hidden');
    });
    return { strip: strip, firstKey: contents.length ? contents[0].getAttribute('data-tab') : null };
  }

  /* Shared: activate a tab inside a scope element. Looks up tab buttons by
     btnClass; toggles is-tab-hidden on every [data-tab] descendant. */
  function setActiveTabIn(scope, key, btnClass) {
    scope.setAttribute('data-active-tab', key);
    scope.querySelectorAll('.' + btnClass).forEach(function(b) {
      var on = b.getAttribute('data-tab-target') === key;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    scope.querySelectorAll('[data-tab]').forEach(function(tc) {
      tc.classList.toggle('is-tab-hidden', tc.getAttribute('data-tab') !== key);
    });
  }

  function bootHeader() {
    var nav = document.getElementById('mobile-nav');
    var overlay = document.getElementById('mobile-nav-overlay');
    var closeBtn = document.getElementById('mobile-nav-close');
    if (!nav || nav.dataset.bound) return;
    nav.dataset.bound = '1';

    var lastFocus = null;
    var megaBuilt = false;

    function openNav() {
      lastFocus = document.activeElement;
      nav.classList.add('is-open');
      overlay.classList.add('is-open');
      document.body.classList.add('mobile-nav-open');
      /* Lazy: build mega-menu drawer wiring the first time the drawer opens.
         Avoids any cost on initial page load — mobile users who never open
         the menu never pay for the DOM walk. */
      if (!megaBuilt) {
        megaBuilt = true;
        bootMobileMega(nav);
      }
      closeBtn.focus();
    }

    function closeNav() {
      nav.classList.remove('is-open');
      overlay.classList.remove('is-open');
      document.body.classList.remove('mobile-nav-open');
      if (lastFocus && typeof lastFocus.focus === 'function') {
        lastFocus.focus();
      }
    }

    document.querySelectorAll('[data-mobile-toggle]').forEach(function(btn) {
      btn.addEventListener('click', openNav);
    });

    closeBtn.addEventListener('click', closeNav);
    overlay.addEventListener('click', closeNav);

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) {
        closeNav();
      }
    });

    /* Single delegated click handler. Covers static AND lazily-built drawer
     * content, so we don't need to re-bind after bootMobileMega injects
     * submenus. Order matters: toggle > leaf-link > generic close. */
    nav.addEventListener('click', function(e) {
      var toggleBtn = e.target.closest('[data-mobile-submenu]');
      if (toggleBtn && nav.contains(toggleBtn)) {
        e.preventDefault();
        var key = toggleBtn.getAttribute('data-mobile-submenu');
        var panel = nav.querySelector('[data-mobile-panel="' + key + '"]');
        if (!panel) return;
        toggleMobileSubmenu(nav, toggleBtn, panel);
        return;
      }
      var tabBtn = e.target.closest('.mobile-nav__tab');
      if (tabBtn && nav.contains(tabBtn)) {
        e.preventDefault();
        var tk = tabBtn.getAttribute('data-tab-target');
        var scope = tabBtn.closest('.mobile-nav__submenu');
        if (scope && tk) setActiveTabIn(scope, tk, 'mobile-nav__tab');
        return;
      }
      var leaf = e.target.closest('.mobile-nav__card, .mobile-nav__split, .mobile-nav__li, .mobile-nav__feature, .mobile-nav__promo-btn, .mobile-nav__sublink--all, .mobile-nav__util');
      if (leaf && nav.contains(leaf)) {
        closeNav();
        return;
      }
      var topLink = e.target.closest('.mobile-nav__link');
      if (topLink && nav.contains(topLink) && !topLink.classList.contains('mobile-nav__toggle')) {
        closeNav();
      }
    });

    /* Single-open accordion: when one submenu opens, collapse siblings. */
    function toggleMobileSubmenu(nav, btn, panel) {
      var open = btn.getAttribute('aria-expanded') === 'true';
      if (!open) {
        nav.querySelectorAll('[data-mobile-submenu][aria-expanded="true"]').forEach(function(other) {
          if (other === btn) return;
          other.setAttribute('aria-expanded', 'false');
          var k = other.getAttribute('data-mobile-submenu');
          var p = nav.querySelector('[data-mobile-panel="' + k + '"]');
          if (p) p.setAttribute('hidden', '');
        });
      }
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (open) panel.setAttribute('hidden', '');
      else panel.removeAttribute('hidden');
    }
  }

  /* ── Mobile mega-menu wiring (lazy) ──
   * Theme blocks are opaque from any parent context, so mobile drawer
   * content cannot be Liquid-rendered. We translate the already-rendered
   * desktop .mega-panel DOM into mobile-nav__* markup at runtime, using
   * snippets/mega-mobile-block.liquid as the markup contract.
   *
   * Two-stage lazy:
   *   Stage 1 (first drawer open): rewrite top-level links to toggles,
   *           insert empty submenu placeholders. ~6 nav items, very cheap.
   *   Stage 2 (first toggle tap):  walk that one panel's children and build
   *           its submenu content. Marked via data-mobile-built so each
   *           panel is built at most once. */
  function bootMobileMega(nav) {
    var panels = document.querySelector('[data-mega-panels]');
    if (!panels) return;
    /* Mobile boot runs after bootMegaMenu has set data-panel-key on each
       panel — use that as the canonical link to the nav item, regardless of
       whether the panel was authored by index or by parent_link string. */
    var allPanels = panels.querySelectorAll('.mega-panel[data-panel-key]');
    var caretSVG = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M4 6l4 4 4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    allPanels.forEach(function(panel) {
      if (panel.getAttribute('data-hide-on-mobile') === 'true') return;
      var key = panel.getAttribute('data-panel-key');
      if (!key) return;
      var item = nav.querySelector('.mobile-nav__item[data-nav-item="' + key + '"]');
      if (!item || item.dataset.mobileMegaBound) return;
      item.dataset.mobileMegaBound = '1';

      var origLink = item.querySelector('.mobile-nav__link');
      if (!origLink) return;
      var origHref = origLink.getAttribute('href') || '#';
      var origLabel = (origLink.textContent || '').trim();
      var isActive = origLink.classList.contains('is-active');

      /* Replace the <a> with a <button> toggle that mirrors the existing
         link styling. Keep the text + chevron; original href moves into
         the submenu as a "View all" link. */
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'mobile-nav__link mobile-nav__toggle' + (isActive ? ' is-active' : '');
      btn.setAttribute('data-mobile-submenu', key);
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('aria-controls', 'mobile-panel-' + key);
      btn.innerHTML = '<span class="mobile-nav__link-text">' + origLabel + '</span><span class="mobile-nav__chev" aria-hidden="true">' + caretSVG + '</span>';
      origLink.replaceWith(btn);

      var submenu = document.createElement('div');
      submenu.className = 'mobile-nav__submenu';
      submenu.id = 'mobile-panel-' + key;
      submenu.setAttribute('data-mobile-panel', key);
      submenu.setAttribute('hidden', '');
      /* Stash the link target + label so buildMobilePanelContent can build
         the "View all" entry on first expand without re-querying. */
      submenu.dataset.origHref = origHref;
      submenu.dataset.origLabel = origLabel;
      submenu.dataset.panelSelector = '[data-panel-key="' + key + '"]';
      item.appendChild(submenu);

      /* Hook lazy build: the first time the toggle is activated (via the
         delegated click handler above), populate this submenu's content. */
      btn.addEventListener('click', function build() {
        if (submenu.dataset.mobileBuilt) return;
        submenu.dataset.mobileBuilt = '1';
        buildMobilePanelContent(panel, submenu);
        btn.removeEventListener('click', build);
      });
    });
  }

  /* Build mobile-drawer content for a panel by cloning the desktop panel's
     inner DOM verbatim. The drawer-scoped CSS in this file's stylesheet
     then re-flows the mega-* blocks into a vertical stack — no parallel
     mobile-nav__* markup tree needed.

     Tab handling: the desktop tab strip (.mega-tabs) is JS-injected into
     the panel's inner container before cloning, so it comes along for the
     ride. cloneNode skips event listeners, so we add a delegated click
     handler on the submenu wrapper that switches tabs locally — the
     desktop strip's own handler stays bound to its own button instances. */
  function buildMobilePanelContent(panel, submenu) {
    var frag = document.createDocumentFragment();

    /* "View all" link — keeps the original parent destination reachable
       once the link itself becomes a toggle. */
    var origHref = submenu.dataset.origHref || '#';
    var origLabel = submenu.dataset.origLabel || '';
    if (origHref && origHref !== '#') {
      var allLink = document.createElement('a');
      allLink.className = 'mobile-nav__sublink--all';
      allLink.href = origHref;
      allLink.textContent = 'View all ' + origLabel + ' →';
      frag.appendChild(allLink);
    }

    var src = panel.querySelector('.mega-panel__inner') || panel;
    var clone = src.cloneNode(true);
    window.NerdioClone?.uniqueIds(clone, submenu.id || 'mobile-mega');
    /* Reset desktop-injected tab state on the clone so the first tab is
       active in the drawer copy regardless of what the user last clicked
       on desktop. The submenu-scoped click handler below keeps the two
       strips independent from then on. */
    var clonedTabs = clone.querySelectorAll('.mega-tab-content[data-tab]');
    if (clonedTabs.length > 0) {
      clonedTabs.forEach(function(tc, i) {
        tc.classList.toggle('is-tab-hidden', i > 0);
      });
      var clonedStrip = clone.querySelector('.mega-tabs');
      if (clonedStrip) {
        clonedStrip.querySelectorAll('.mega-tabs__btn').forEach(function(b, i) {
          b.classList.toggle('is-active', i === 0);
          b.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
        });
        submenu.setAttribute('data-active-tab', clonedTabs[0].getAttribute('data-tab') || '');
      }
      submenu.addEventListener('click', function(e) {
        var btn = e.target.closest('.mega-tabs__btn');
        if (!btn || !submenu.contains(btn)) return;
        e.preventDefault();
        var tk = btn.getAttribute('data-tab-target');
        if (tk) setActiveTabIn(submenu, tk, 'mega-tabs__btn');
      });
    }
    /* Strip data-anim-* on the clone so the entrance reveal observer
       doesn't double-fire when the user pulls open the drawer — the
       desktop instance already animated when the page loaded. */
    clone.querySelectorAll('[data-anim-in]').forEach(function(el) {
      el.removeAttribute('data-anim-in');
      el.removeAttribute('data-anim-duration');
      el.removeAttribute('data-anim-delay');
      el.removeAttribute('data-anim-ease');
      el.classList.add('is-revealed');
    });
    clone.classList.add('mobile-nav__panel-clone');
    frag.appendChild(clone);

    submenu.appendChild(frag);
  }

  function bootMegaMenu() {
    var megaNav = document.querySelector('[data-mega-nav]');
    var panels = document.querySelector('[data-mega-panels]');
    if (!megaNav || !panels || megaNav.dataset.megaBound) return;
    megaNav.dataset.megaBound = '1';

    // Decorate nav items that have a corresponding mega panel, and build tab
    // strips inside panels. We do this in JS because theme blocks can't be
    // introspected from a parent section/block.
    var allPanels = panels.querySelectorAll('.mega-panel');
    var caretSVG = '<svg class="site-header__nav-caret" width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true"><path d="M2 4l3 3 3-3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    allPanels.forEach(function(panel) {
      // Resolve panel → nav item by menu_index first (stable across renames),
      // falling back to the legacy parent_link handle match. Whichever wins,
      // we cache the resolved key on the panel so the rest of the JS only
      // ever reads data-panel-key.
      var key = '';
      var navItem = null;
      var idxAttr = panel.getAttribute('data-panel-for-index');
      if (idxAttr) {
        navItem = megaNav.querySelector('.site-header__nav-item[data-nav-index="' + idxAttr + '"]');
        if (navItem) key = navItem.getAttribute('data-nav-item') || ('idx-' + idxAttr);
      }
      if (!key) {
        key = panel.getAttribute('data-panel-for') || '';
        if (key) navItem = megaNav.querySelector('.site-header__nav-item[data-nav-item="' + key + '"]');
      }
      if (!key) return;
      panel.setAttribute('data-panel-key', key);
      if (navItem && !navItem.classList.contains('has-mega')) {
        navItem.classList.add('has-mega');
        var link = navItem.querySelector('.site-header__nav-link');
        if (link) {
          link.setAttribute('aria-haspopup', 'true');
          link.setAttribute('aria-expanded', 'false');
          link.insertAdjacentHTML('beforeend', caretSVG);
        }
      }

      // Build tab strip from the panel's tab-content children, if any.
      // Uses the shared buildTabStrip / setActiveTabIn helpers (also reused
      // by bootMobileMega) so behavior stays identical across breakpoints.
      var tabs = panel.querySelectorAll(':scope .mega-tab-content[data-tab]');
      if (tabs.length > 0 && !panel.dataset.tabsInited) {
        panel.dataset.tabsInited = '1';
        var built = buildTabStrip({
          contents: tabs,
          stripClass: 'mega-tabs',
          btnClass: 'mega-tabs__btn'
        });
        panel.setAttribute('data-has-tabs', 'true');
        panel.setAttribute('data-active-tab', built.firstKey || '');
        built.strip.addEventListener('click', function(e) {
          var btn = e.target.closest('.mega-tabs__btn');
          if (!btn) return;
          e.preventDefault();
          var tk = btn.getAttribute('data-tab-target');
          if (tk) setActiveTabIn(panel, tk, 'mega-tabs__btn');
        });
        var inner = panel.querySelector('.mega-panel__inner');
        if (inner) inner.insertBefore(built.strip, inner.firstChild);
      }
    });

    var items = megaNav.querySelectorAll('.site-header__nav-item.has-mega');
    var openTimer = null;
    var closeTimer = null;
    var currentKey = null;
    var editorLocked = false;

    function showPanel(key, force) {
      clearTimeout(closeTimer);
      if (editorLocked && currentKey && currentKey !== key && !force) return;
      if (currentKey === key) return;
      currentKey = key;
      allPanels.forEach(function(p) {
        p.classList.toggle('is-active', p.getAttribute('data-panel-key') === key);
      });
      panels.classList.add('is-open');
      panels.setAttribute('aria-hidden', 'false');
      items.forEach(function(it) {
        var isCur = it.getAttribute('data-nav-item') === key;
        it.classList.toggle('is-open', isCur);
        var link = it.querySelector('.site-header__nav-link');
        if (link) link.setAttribute('aria-expanded', isCur ? 'true' : 'false');
      });
    }

    function hidePanel(force) {
      if (editorLocked && !force) return;
      panels.classList.remove('is-open');
      panels.setAttribute('aria-hidden', 'true');
      allPanels.forEach(function(p) { p.classList.remove('is-active'); });
      items.forEach(function(it) {
        it.classList.remove('is-open');
        var link = it.querySelector('.site-header__nav-link');
        if (link) link.setAttribute('aria-expanded', 'false');
      });
      currentKey = null;
    }

    function scheduleOpen(key) {
      if (editorLocked && currentKey && currentKey !== key) return;
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
      openTimer = setTimeout(function() { showPanel(key); }, 80);
    }

    function scheduleClose() {
      if (editorLocked) return;
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
      closeTimer = setTimeout(hidePanel, 180);
    }

    items.forEach(function(item) {
      var key = item.getAttribute('data-nav-item');
      item.addEventListener('mouseenter', function() { scheduleOpen(key); });
      item.addEventListener('mouseleave', scheduleClose);
      item.addEventListener('focusin', function() { showPanel(key); });
    });

    panels.addEventListener('mouseenter', function() {
      clearTimeout(closeTimer);
    });
    panels.addEventListener('mouseleave', scheduleClose);

    megaNav.addEventListener('focusout', function(e) {
      if (!megaNav.contains(e.relatedTarget) && !panels.contains(e.relatedTarget)) {
        scheduleClose();
      }
    });
    panels.addEventListener('focusout', function(e) {
      if (!panels.contains(e.relatedTarget) && !megaNav.contains(e.relatedTarget)) {
        scheduleClose();
      }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && currentKey) {
        editorLocked = false;
        panels.removeAttribute('data-editor-locked');
        window.NerdioMegaEditorPanelKey = '';
        hidePanel(true);
        var active = megaNav.querySelector('.site-header__nav-item.has-mega .site-header__nav-link');
        if (active) active.focus();
      }
    });

    function lockEditorPanel(panel) {
      if (!panel || !panels.contains(panel)) return;
      var key = panel.getAttribute('data-panel-key');
      if (!key) return;
      editorLocked = true;
      panels.setAttribute('data-editor-locked', 'true');
      window.NerdioMegaEditorPanelKey = key;
      showPanel(key, true);
    }

    function unlockEditorPanel(closePanel) {
      editorLocked = false;
      panels.removeAttribute('data-editor-locked');
      if (closePanel) {
        window.NerdioMegaEditorPanelKey = '';
        hidePanel(true);
      }
    }

    panels._megaMenuEditor = {
      lockPanel: lockEditorPanel,
      unlock: unlockEditorPanel
    };

    if (window.Shopify && window.Shopify.designMode && window.NerdioMegaEditorPanelKey) {
      var rememberedPanel = panels.querySelector('.mega-panel[data-panel-key="' + window.NerdioMegaEditorPanelKey + '"]');
      if (rememberedPanel) lockEditorPanel(rememberedPanel);
    }

  }

  function megaPanelForEditorEvent(event, panels) {
    var target = event && event.target;
    if (!target || !panels) return null;
    var closest = target.closest && target.closest('.mega-panel');
    if (closest && panels.contains(closest)) return closest;
    var child = target.querySelector && target.querySelector('.mega-panel');
    if (child && panels.contains(child)) return child;
    return null;
  }

  function handleMegaEditorBlockSelect(event) {
    var panels = document.querySelector('[data-mega-panels]');
    if (!panels || !panels._megaMenuEditor) return;
    var panel = megaPanelForEditorEvent(event, panels);
    if (panel) panels._megaMenuEditor.lockPanel(panel);
    else panels._megaMenuEditor.unlock(true);
  }

  function handleMegaEditorSectionDeselect(event) {
    var target = event && event.target;
    var panels = target && target.querySelector && target.querySelector('[data-mega-panels]');
    if (panels && panels._megaMenuEditor) panels._megaMenuEditor.unlock(true);
  }

  function bootScrollShadow() {
    var hdr = document.querySelector('.site-header[data-shadow="true"]');
    if (!hdr || hdr.dataset.shadowBound) return;
    hdr.dataset.shadowBound = '1';
    var onScroll = function() {
      if (window.scrollY > 4) hdr.classList.add('is-scrolled');
      else hdr.classList.remove('is-scrolled');
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  function bootAll() {
    bootHeader();
    bootMegaMenu();
    bootScrollShadow();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }
  document.addEventListener('shopify:section:load', bootAll);
  document.addEventListener('shopify:block:select', handleMegaEditorBlockSelect);
  document.addEventListener('shopify:section:deselect', handleMegaEditorSectionDeselect);

  /* Graceful fallback: if <shopify-account> hasn't upgraded after 2s,
     replace it with a plain link to the hosted account portal. */
  function shopifyAccountFallback() {
    var els = document.querySelectorAll('shopify-account');
    if (!els.length) return;
    setTimeout(function() {
      if (typeof customElements !== 'undefined' && customElements.get('shopify-account')) return;
      els.forEach(function(el) {
        var link = document.createElement('a');
        link.href = el.getAttribute('data-fallback-url') || '/account';
        link.className = el.className;
        link.setAttribute('aria-label', 'Account');
        link.innerHTML = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>';
        el.replaceWith(link);
      });
    }, 2000);
  }
  if (document.readyState !== 'loading') shopifyAccountFallback();
  else document.addEventListener('DOMContentLoaded', shopifyAccountFallback);

  (function() {
    function bootHeaderSearch(root) {
      if (!root || root.dataset.bound) return;
      root.dataset.bound = '1';

      var form = root.querySelector('[data-header-search-form]');
      var input = root.querySelector('[data-header-search-input]');
      var category = root.querySelector('[data-header-search-category]');
      var hiddenQuery = root.querySelector('[data-header-search-query]');
      var results = root.querySelector('[data-header-search-results]');
      var categoryShell = root.querySelector('[data-header-category-select]');
      var categoryTrigger = root.querySelector('[data-header-category-trigger]');
      var categoryValue = root.querySelector('[data-header-category-value]');
      var categoryPopover = root.querySelector('[data-header-category-popover]');
      if (!form || !input || !category || !hiddenQuery || !results) return;

      var timer = null;
      var controller = null;
      var activeQuery = '';

      function escapeHtml(value) {
        return String(value == null ? '' : value).replace(/[&<>"']/g, function(character) {
          return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[character];
        });
      }

      function selectedOption() {
        return category.options[category.selectedIndex];
      }

      function closeCategory() {
        if (!categoryShell) return;
        categoryShell.classList.remove('is-open');
        if (categoryTrigger) categoryTrigger.setAttribute('aria-expanded', 'false');
        if (categoryPopover) categoryPopover.setAttribute('aria-hidden', 'true');
      }

      function syncCategory() {
        var selected = selectedOption();
        if (categoryValue && selected) categoryValue.textContent = selected.textContent;
        root.querySelectorAll('[data-header-category-option]').forEach(function(option) {
          var active = option.dataset.value === category.value;
          option.classList.toggle('is-active', active);
          option.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      }

      function qualifiedQuery() {
        var term = input.value.trim();
        var qualifier = selectedOption().dataset.query || '';
        return [term, qualifier].filter(Boolean).join(' ');
      }

      function cleanSearchUrl() {
        var term = input.value.trim();
        var option = selectedOption();
        if (!term && option.dataset.url) return option.dataset.url;
        var query = qualifiedQuery();
        return root.dataset.searchUrl + '?type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(query);
      }

      function closeResults() {
        results.hidden = true;
        results.innerHTML = '';
      }

      function formatMoney(value) {
        var amount = Number(value) || 0;
        if (typeof value !== 'string') amount = amount / 100;
        try {
          return amount.toLocaleString(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || root.dataset.currency || 'USD' });
        } catch (error) {
          return '$' + amount.toFixed(2);
        }
      }

      function render(data, requested) {
        if (requested !== activeQuery) return;
        var products = data && data.resources && data.resources.results && data.resources.results.products || [];
        if (!products.length) {
          results.innerHTML = '<div class="site-header__search-empty">No products found. Press Enter to search the full catalog.</div>';
          results.hidden = false;
          return;
        }

        var html = products.map(function(product) {
          var image = product.image || product.featured_image && product.featured_image.url || '';
          var meta = [product.type].filter(Boolean).join(' · ');
          return '<a class="site-header__search-result" role="option" href="' + escapeHtml(product.url) + '">' +
            (image ? '<img class="site-header__search-result-image" src="' + escapeHtml(image) + '" alt="" loading="lazy">' : '<span class="site-header__search-result-image"></span>') +
            '<span class="site-header__search-result-copy"><span class="site-header__search-result-title">' + escapeHtml(product.title) + '</span>' +
            (meta ? '<span class="site-header__search-result-meta">' + escapeHtml(meta) + '</span>' : '') + '</span>' +
            '<span class="site-header__search-result-price">' + formatMoney(product.price) + '</span></a>';
        }).join('');
        html += '<a class="site-header__search-all" href="' + cleanSearchUrl() + '">View all matching products</a>';
        results.innerHTML = html;
        results.hidden = false;
      }

      function fetchResults() {
        var term = input.value.trim();
        if (term.length < 2) { closeResults(); return; }
        var query = qualifiedQuery();
        activeQuery = query;
        if (controller) controller.abort();
        controller = new AbortController();
        var url = root.dataset.predictiveUrl + '?q=' + encodeURIComponent(query) +
          '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last' +
          '&resources[options][fields]=title,product_type,variants.title,variants.sku,tag';
        fetch(url, { signal: controller.signal, headers: { Accept: 'application/json' } })
          .then(function(response) { return response.json(); })
          .then(function(data) { render(data, query); })
          .catch(function(error) { if (error.name !== 'AbortError') closeResults(); });
      }

      function queueSearch() {
        clearTimeout(timer);
        timer = setTimeout(fetchResults, 160);
      }

      input.addEventListener('input', queueSearch);
      category.addEventListener('change', function() {
        syncCategory();
        if (input.value.trim().length >= 2) fetchResults();
      });

      if (categoryTrigger && categoryShell) {
        categoryTrigger.addEventListener('click', function() {
          var opening = !categoryShell.classList.contains('is-open');
          closeCategory();
          if (opening) {
            categoryShell.classList.add('is-open');
            categoryTrigger.setAttribute('aria-expanded', 'true');
            if (categoryPopover) categoryPopover.setAttribute('aria-hidden', 'false');
          }
        });
      }

      root.querySelectorAll('[data-header-category-option]').forEach(function(option) {
        option.addEventListener('click', function() {
          category.value = option.dataset.value;
          category.dispatchEvent(new Event('change', { bubbles: true }));
          closeCategory();
          if (categoryTrigger) categoryTrigger.focus();
        });
      });
      syncCategory();

      form.addEventListener('submit', function(event) {
        if (!input.value.trim() && selectedOption().dataset.url) {
          event.preventDefault();
          window.location.href = selectedOption().dataset.url;
          return;
        }
        hiddenQuery.value = qualifiedQuery();
      });

      input.addEventListener('keydown', function(event) {
        if (event.key === 'Escape') { closeResults(); closeCategory(); return; }
        if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
        var links = Array.prototype.slice.call(results.querySelectorAll('.site-header__search-result'));
        if (!links.length) return;
        event.preventDefault();
        var current = results.querySelector('.site-header__search-result.is-active');
        var index = current ? links.indexOf(current) : -1;
        index = event.key === 'ArrowDown' ? (index + 1) % links.length : (index - 1 + links.length) % links.length;
        links.forEach(function(link) { link.classList.remove('is-active'); });
        links[index].classList.add('is-active');
        links[index].focus();
      });

      document.addEventListener('click', function(event) {
        if (!root.contains(event.target)) { closeResults(); closeCategory(); }
        else if (categoryShell && !categoryShell.contains(event.target)) closeCategory();
      });

      document.addEventListener('keydown', function(event) {
        if (event.key !== 'Escape' || !categoryShell || !categoryShell.classList.contains('is-open')) return;
        closeCategory();
        if (categoryTrigger) categoryTrigger.focus();
      });

      var primaryNav = root.closest('.site-header') && root.closest('.site-header').querySelector('[data-mega-nav]');
      if (primaryNav) {
        primaryNav.addEventListener('pointerenter', function() {
          closeResults();
          closeCategory();
        });
      }
    }

    function bootAllHeaderSearch() {
      document.querySelectorAll('[data-header-search]').forEach(bootHeaderSearch);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootAllHeaderSearch);
    else bootAllHeaderSearch();
    document.addEventListener('shopify:section:load', bootAllHeaderSearch);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-merchandising"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function bootHomeMerch(root) {
      if (!root || root.dataset.bound) return;
      root.dataset.bound = '1';

      var limit = parseInt(root.dataset.limit, 10) || 4;
      var recentRail = root.querySelector('[data-home-rail="recent"]');
      var recentGrid = root.querySelector('[data-home-recent]');
      var inspiredRail = root.querySelector('[data-home-rail="inspired"]');
      var inspiredGrid = root.querySelector('[data-home-inspired]');
      var recent = window.nerdioGetRecent ? window.nerdioGetRecent() : [];
      var usable = recent.filter(function(item) { return item && item.handle; }).slice(0, limit);

      function reveal(rail) {
        if (!rail) return;
        var editorPlaceholder = root.querySelector('[data-home-editor-placeholder]');
        if (editorPlaceholder) editorPlaceholder.hidden = true;
        rail.hidden = false;
        root.hidden = false;
      }

      function initCards(container) {
        if (window.initProductCards) window.initProductCards(container);
      }

      if (recentRail && recentGrid && usable.length) {
        recentGrid.innerHTML = usable.map(function() { return '<div class="home-merch__loading" aria-hidden="true"></div>'; }).join('');
        Promise.all(usable.map(function(item) {
          return fetch('/products/' + encodeURIComponent(item.handle) + '?view=card')
            .then(function(response) { return response.ok ? response.text() : ''; })
            .catch(function() { return ''; });
        })).then(function(cards) {
          var html = cards.filter(function(card) { return card && card.trim(); }).join('');
          if (!html) { recentRail.hidden = true; return; }
          recentGrid.innerHTML = html;
          initCards(recentGrid);
          reveal(recentRail);
        });
      }

      var seed = recent.find(function(item) { return item && item.id; });
      if (inspiredRail && inspiredGrid && seed) {
        inspiredGrid.innerHTML = Array.from({ length: limit }).map(function() { return '<div class="home-merch__loading" aria-hidden="true"></div>'; }).join('');
        var url = root.dataset.recommendationsUrl + '?section_id=' + encodeURIComponent(root.dataset.sectionId) +
          '&product_id=' + encodeURIComponent(seed.id) + '&limit=' + limit + '&intent=related';
        fetch(url)
          .then(function(response) { return response.text(); })
          .then(function(html) {
            var documentFragment = new DOMParser().parseFromString(html, 'text/html');
            var template = documentFragment.querySelector('[data-home-recommendation-fragment]');
            var cards = template ? template.innerHTML.trim() : '';
            if (!cards) { inspiredRail.hidden = true; return; }
            inspiredGrid.innerHTML = cards;
            initCards(inspiredGrid);
            reveal(inspiredRail);
          })
          .catch(function() { inspiredRail.hidden = true; });
      }
    }

    function bootAllHomeMerch() {
      document.querySelectorAll('[data-home-merchandising]').forEach(bootHomeMerch);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootAllHomeMerch);
    else bootAllHomeMerch();
    document.addEventListener('shopify:section:load', bootAllHomeMerch);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-404"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const form = document.querySelector('[data-s404-search]');
    if (!form || form.dataset.bound) return;
    form.dataset.bound = '1';

    const input = form.querySelector('[data-s404-input]');
    const pop = form.querySelector('[data-s404-pop]');
    let timer = null;
    let abortCtl = null;
    let activeIdx = -1;

    function fmtMoney(raw) {
      if (raw == null) return '';
      const num = typeof raw === 'number' ? raw / 100 : parseFloat(raw);
      if (isNaN(num)) return String(raw);
      try {
        return num.toLocaleString(undefined, {
          style: 'currency',
          currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
        });
      } catch (e) { return '$' + num.toFixed(2); }
    }

    function escapeHtml(s) {
      return String(s == null ? '' : s)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }

    function open() { pop.classList.add('is-open'); }
    function close() { pop.classList.remove('is-open'); activeIdx = -1; }

    function productRow(p) {
      const img = (p.featured_image && p.featured_image.url) || p.image || '';
      const price = fmtMoney(p.price != null ? p.price : p.price_min);
      return ''
        + '<a class="s404__result" href="' + escapeHtml(p.url) + '" role="option">'
        +   '<span class="s404__result-img">' + (img ? '<img src="' + escapeHtml(img) + '" alt="" loading="lazy">' : '') + '</span>'
        +   '<span class="s404__result-title">' + escapeHtml(p.title) + '</span>'
        +   '<span class="s404__result-price">' + price + '</span>'
        + '</a>';
    }

    function genericRow(item, kind) {
      const img = (item.featured_image && item.featured_image.url) || item.image || '';
      const meta = item.published_at ? new Date(item.published_at).toLocaleDateString() : kind;
      return ''
        + '<a class="s404__result" href="' + escapeHtml(item.url) + '" role="option">'
        +   '<span class="s404__result-img s404__result-img--placeholder">' + (img ? '<img src="' + escapeHtml(img) + '" alt="" loading="lazy">' : iconFor(kind)) + '</span>'
        +   '<span class="s404__result-title">' + escapeHtml(item.title) + '</span>'
        +   '<span class="s404__result-kind">' + escapeHtml(meta) + '</span>'
        + '</a>';
    }

    function iconFor(kind) {
      if (kind === 'collection') return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></svg>';
      if (kind === 'article')   return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h12v16H4z"/><path d="M16 4l4 4v12h-4"/><path d="M7 9h6M7 13h6M7 17h4"/></svg>';
      return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M6 4h9l5 5v11H6z"/><path d="M14 4v5h5"/></svg>';
    }

    function group(title, rows) {
      if (!rows.length) return '';
      return '<div class="s404__group"><div class="s404__group-head">' + escapeHtml(title) + '</div>' + rows.join('') + '</div>';
    }

    function render(data, q) {
      const r = (data.resources || {}).results || {};
      const products = (r.products || []).slice(0, 4);
      const collections = (r.collections || []).slice(0, 3);
      const pages = (r.pages || []).slice(0, 3);
      const articles = (r.articles || []).slice(0, 3);
      const total = products.length + collections.length + pages.length + articles.length;

      if (!total) {
        pop.innerHTML = '<div class="s404__search-empty">No results for &ldquo;' + escapeHtml(q) + '&rdquo;. Press Enter to search anyway.</div>';
        open();
        return;
      }

      const html =
          group('Products', products.map(productRow))
        + group('Collections', collections.map(c => genericRow(c, 'collection')))
        + group('Pages', pages.map(p => genericRow(p, 'page')))
        + group('Articles', articles.map(a => genericRow(a, 'article')));

      const allUrl = '/search?q=' + encodeURIComponent(q) + '&type=product,collection,article,page';
      pop.innerHTML = html + '<a class="s404__search-more" href="' + escapeHtml(allUrl) + '">View all results &rarr;</a>';
      open();
    }

    function runSearch(q) {
      if (abortCtl) abortCtl.abort();
      abortCtl = new AbortController();
      pop.innerHTML = '<div class="s404__search-loading">Searching…</div>';
      open();
      const url = '/search/suggest.json?q=' + encodeURIComponent(q)
        + '&resources[type]=product,collection,page,article'
        + '&resources[limit]=4'
        + '&resources[limit_scope]=each'
        + '&resources[options][unavailable_products]=last';
      fetch(url, { signal: abortCtl.signal })
        .then(r => r.json())
        .then(data => render(data, q))
        .catch(err => {
          if (err.name === 'AbortError') return;
          pop.innerHTML = '<div class="s404__search-empty">Search is temporarily unavailable.</div>';
          open();
        });
    }

    input.addEventListener('input', () => {
      const q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { close(); return; }
      timer = setTimeout(() => runSearch(q), 200);
    });

    input.addEventListener('focus', () => {
      if (input.value.trim().length >= 2) open();
    });

    input.addEventListener('keydown', (e) => {
      if (!pop.classList.contains('is-open')) return;
      const items = Array.from(pop.querySelectorAll('.s404__result, .s404__search-more'));
      if (e.key === 'ArrowDown') { e.preventDefault(); activeIdx = Math.min(items.length - 1, activeIdx + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); activeIdx = Math.max(0, activeIdx - 1); }
      else if (e.key === 'Enter' && activeIdx >= 0 && items[activeIdx]) {
        e.preventDefault();
        window.location.href = items[activeIdx].href;
        return;
      } else if (e.key === 'Escape') { close(); input.blur(); return; }
      items.forEach((r, i) => r.classList.toggle('is-active', i === activeIdx));
    });

    document.addEventListener('click', (e) => {
      if (!form.contains(e.target)) close();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"] && !Shopify.designMode) return;
  try {
    
  function initBlogPost(root) {
    if (root.dataset.bound) return;
    root.dataset.bound = '1';

    const bar = root.querySelector('[data-bp-bar]');
    if (bar) {
      const body = root.querySelector('.bp__body');
      function updateProgress() {
        if (!body) return;
        const rect  = body.getBoundingClientRect();
        const total = rect.height - window.innerHeight;
        const scrolled = Math.min(Math.max(-rect.top, 0), Math.max(total, 1));
        bar.style.width = (total > 0 ? (scrolled / total) * 100 : 0) + '%';
      }
      window.addEventListener('scroll', updateProgress, { passive: true });
      window.addEventListener('resize', updateProgress);
      updateProgress();
    }

    const copyBtn = root.querySelector('[data-bp-copy]');
    const tip     = root.querySelector('[data-bp-tip]');
    if (copyBtn && tip) {
      copyBtn.addEventListener('click', async () => {
        try {
          await navigator.clipboard.writeText(window.location.href);
          tip.textContent = 'Copied!';
          tip.classList.add('is-visible');
          setTimeout(() => { tip.classList.remove('is-visible'); setTimeout(() => { tip.textContent = 'Copy'; }, 200); }, 1400);
        } catch {
          tip.textContent = 'Error';
          tip.classList.add('is-visible');
          setTimeout(() => tip.classList.remove('is-visible'), 1400);
        }
      });
    }
  }

  function bootBlogPost() {
    document.querySelectorAll('[data-bp]').forEach(initBlogPost);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootBlogPost);
  } else {
    bootBlogPost();
  }
  document.addEventListener('shopify:section:load', bootBlogPost);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
  function initBlogList(root) {
    if (root.dataset.bound) return;
    root.dataset.bound = '1';

    const cards    = Array.from(root.querySelectorAll('[data-card]'));
    const searchEl = root.querySelector('[data-blp-search]');
    const clearEl  = root.querySelector('[data-blp-clear]');
    const sortOpen = root.querySelector('[data-blp-sort-open]');
    const sortLabel= root.querySelector('[data-blp-sort-label]');
    const sortPop  = root.querySelector('[data-blp-sort-popover]');
    const sortClose= root.querySelector('[data-blp-sort-close]');
    const sortItems= Array.from(root.querySelectorAll('[data-blp-sort-value]'));
    const emptyEl  = root.querySelector('[data-blp-empty]');
    const chipEls  = Array.from(root.querySelectorAll('[data-filter-tag]'));
    const grid     = root.querySelector('.blp__grid');

    let state = { query: '', tag: 'all', sort: 'newest' };

    function apply() {
      const q = state.query.trim().toLowerCase();
      let visible = 0;
      cards.forEach((card) => {
        const hasTag = state.tag === 'all' || (' ' + (card.dataset.tags || '') + ' ').indexOf(' ' + state.tag + ' ') !== -1;
        const matches = q === '' || (card.dataset.search || '').indexOf(q) !== -1;
        const show = hasTag && matches;
        card.classList.toggle('is-hidden', !show);
        if (show) visible++;
      });
      if (emptyEl) emptyEl.hidden = visible > 0;
      if (grid) {
        const cs = Array.from(grid.querySelectorAll('[data-card]'));
        cs.sort((a, b) => {
          switch (state.sort) {
            case 'oldest': return parseInt(a.dataset.date, 10) - parseInt(b.dataset.date, 10);
            case 'az':     return a.dataset.title.localeCompare(b.dataset.title);
            case 'za':     return b.dataset.title.localeCompare(a.dataset.title);
            default:       return parseInt(b.dataset.date, 10) - parseInt(a.dataset.date, 10);
          }
        });
        cs.forEach((el) => grid.appendChild(el));
      }
    }

    if (searchEl) {
      searchEl.addEventListener('input', () => {
        state.query = searchEl.value;
        if (clearEl) clearEl.hidden = state.query === '';
        apply();
      });
    }
    if (clearEl) {
      clearEl.addEventListener('click', () => {
        if (!searchEl) return;
        searchEl.value = ''; state.query = ''; clearEl.hidden = true;
        searchEl.focus(); apply();
      });
    }
    function closeSort() {
      if (!sortPop) return;
      sortPop.classList.remove('is-open');
      sortPop.setAttribute('aria-hidden', 'true');
      if (sortOpen) sortOpen.setAttribute('aria-expanded', 'false');
    }
    function openSort() {
      if (!sortPop) return;
      sortPop.classList.add('is-open');
      sortPop.setAttribute('aria-hidden', 'false');
      if (sortOpen) sortOpen.setAttribute('aria-expanded', 'true');
    }
    if (sortOpen) {
      sortOpen.addEventListener('click', (e) => {
        e.stopPropagation();
        sortPop.classList.contains('is-open') ? closeSort() : openSort();
      });
    }
    if (sortClose) sortClose.addEventListener('click', closeSort);
    document.addEventListener('click', (e) => {
      if (!sortPop || !sortPop.classList.contains('is-open')) return;
      if (sortPop.contains(e.target) || (sortOpen && sortOpen.contains(e.target))) return;
      closeSort();
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeSort(); });
    sortItems.forEach((item) => {
      item.addEventListener('click', () => {
        state.sort = item.dataset.blpSortValue;
        sortItems.forEach((i) => {
          i.classList.toggle('is-active', i === item);
          const dot = i.querySelector('.blp__sort-active-dot');
          if (i === item && !dot) { const s = document.createElement('span'); s.className = 'blp__sort-active-dot'; i.appendChild(s); }
          else if (i !== item && dot) dot.remove();
        });
        if (sortLabel) sortLabel.textContent = item.dataset.blpSortName || item.textContent;
        closeSort(); apply();
      });
    });
    chipEls.forEach((chip) => {
      chip.addEventListener('click', () => {
        state.tag = chip.dataset.filterTag;
        chipEls.forEach((c) => c.classList.toggle('is-active', c === chip));
        apply();
      });
    });
    apply();
  }

  function bootBlogList() {
    document.querySelectorAll('[data-blp]').forEach(initBlogList);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootBlogList);
  } else {
    bootBlogList();
  }
  document.addEventListener('shopify:section:load', bootBlogList);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-customer-addresses"]) return;
  try {
    
  (function () {
    var section = document.querySelector('.cust-addr');
    if (!section) return;
    section.addEventListener('click', function (e) {
      var t = e.target;
      if (t.matches('[data-cust-addr-add]')) {
        var nu = section.querySelector('[data-cust-addr-new]');
        if (nu) { nu.hidden = false; nu.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      } else if (t.matches('[data-cust-addr-new-cancel]')) {
        section.querySelector('[data-cust-addr-new]').hidden = true;
      } else if (t.matches('[data-cust-addr-edit]')) {
        var id = t.getAttribute('data-cust-addr-edit');
        var item = section.querySelector('[data-cust-addr-item="' + id + '"]');
        if (item) {
          item.querySelector('.cust-addr__view').style.display = 'none';
          item.querySelector('[data-cust-addr-form="' + id + '"]').hidden = false;
        }
      } else if (t.matches('[data-cust-addr-cancel]')) {
        var cid = t.getAttribute('data-cust-addr-cancel');
        var citem = section.querySelector('[data-cust-addr-item="' + cid + '"]');
        if (citem) {
          citem.querySelector('.cust-addr__view').style.display = '';
          citem.querySelector('[data-cust-addr-form="' + cid + '"]').hidden = true;
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-customer-login"]) return;
  try {
    
  (function () {
    var section = document.querySelector('[data-cust-auth]');
    if (!section) return;
    var login = section.querySelector('[data-cust-panel="login"]');
    var recover = section.querySelector('[data-cust-panel="recover"]');
    function show(which) {
      login.hidden = which !== 'login';
      recover.hidden = which !== 'recover';
    }
    function syncFromHash() {
      show(location.hash === '#recover' ? 'recover' : 'login');
    }
    section.addEventListener('click', function (e) {
      var target = e.target.closest('[data-cust-show-recover], [data-cust-show-login]');
      if (!target) return;
      e.preventDefault();
      var which = target.matches('[data-cust-show-recover]') ? 'recover' : 'login';
      history.replaceState(null, '', which === 'recover' ? '#recover' : '#');
      show(which);
    });
    syncFromHash();
    window.addEventListener('hashchange', syncFromHash);
    // If recover form posted successfully, scroll its panel into view + focus message
    var ok = section.querySelector('[data-cust-recover-success]');
    if (ok) { show('recover'); ok.focus({ preventScroll: false }); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  (function() {
    function bootSearchFallback(section) {
      var fallback = section && section.querySelector('[data-search-fallback]');
      if (!fallback || fallback.dataset.bound) return;
      fallback.dataset.bound = '1';

      var query = (fallback.dataset.query || '').trim();
      var endpoint = fallback.dataset.predictiveUrl;
      var grid = fallback.querySelector('[data-search-fallback-grid]');
      if (!query || !endpoint || !grid) return;

      fetch(endpoint + '?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last', {
        headers: { Accept: 'application/json' }
      })
        .then(function(response) { return response.ok ? response.json() : Promise.reject(new Error('Search fallback failed')); })
        .then(function(data) {
          var products = data && data.resources && data.resources.results && data.resources.results.products || [];
          if (!products.length) return;
          return Promise.all(products.map(function(product) {
            return fetch('/products/' + encodeURIComponent(product.handle) + '?view=card')
              .then(function(response) { return response.ok ? response.text() : ''; });
          })).then(function(cards) {
            var markup = cards.filter(Boolean).join('');
            if (!markup) return;
            grid.innerHTML = markup;
            fallback.hidden = false;
            var empty = section.querySelector('[data-search-empty]');
            if (empty) empty.hidden = true;
            var count = fallback.querySelector('[data-search-fallback-count]');
            if (count) count.textContent = products.length;
            var title = section.querySelector('[data-search-title]');
            if (title) title.textContent = products.length + ' suggested product' + (products.length === 1 ? '' : 's') + ' for “' + query + '”';
          });
        })
        .catch(function() {
          /* Keep the server-rendered empty state when suggestions are unavailable. */
        });
    }

    function bootAllSearchFallback() {
      document.querySelectorAll('.sr').forEach(bootSearchFallback);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootAllSearchFallback);
    else bootAllSearchFallback();
    document.addEventListener('shopify:section:load', bootAllSearchFallback);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marquee"] && !Shopify.designMode) return;
  try {
    
  function bootMarquee(root) {
    if (root.dataset.bound) return;
    root.dataset.bound = '1';
    const master = root.querySelector('.mq__group--master');
    if (!master) return;

    // Insert separators between items in master group
    const tpl = root.querySelector('template[data-mq-sep]');
    if (tpl && tpl.content && tpl.content.firstElementChild) {
      const sepEl = tpl.content.firstElementChild;
      const items = Array.from(master.querySelectorAll(':scope > .shopify-block'));
      items.forEach(item => {
        item.insertAdjacentElement('afterend', sepEl.cloneNode(true));
      });
    }

    // Clone the master group 3 times for the seamless infinite scroll
    const track = root.querySelector('.mq__track');
    for (let i = 0; i < 3; i++) {
      const clone = master.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('inert', '');
      window.NerdioClone?.uniqueIds(clone, root.id + '-' + i);
      track.appendChild(clone);
    }
  }

  function bootAllMarquees() {
    document.querySelectorAll('[data-marquee]').forEach(bootMarquee);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAllMarquees);
  } else {
    bootAllMarquees();
  }
  document.addEventListener('shopify:section:load', bootAllMarquees);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-addons"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-addons')) {
    customElements.define('product-addons', class ProductAddons extends HTMLElement {
      connectedCallback() {
        if (this._connected) return;
        this._connected = true;
        this._handleClick = this.handleClick.bind(this);
        this._handleChange = this.handleChange.bind(this);
        this._handleSubmit = this.handleSubmit.bind(this);
        this._syncSingleAddons = this.syncSingleAddons.bind(this);
        this.addEventListener('click', this._handleClick);
        this.addEventListener('change', this._handleChange);
        this.addEventListener('submit', this._handleSubmit);
        document.addEventListener('cart:updated', this._syncSingleAddons);
        document.addEventListener('cart:item-added', this._syncSingleAddons);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this._handleClick);
        this.removeEventListener('change', this._handleChange);
        this.removeEventListener('submit', this._handleSubmit);
        document.removeEventListener('cart:updated', this._syncSingleAddons);
        document.removeEventListener('cart:item-added', this._syncSingleAddons);
        this._connected = false;
      }

      syncSingleAddons(event) {
        const cart = event.detail?.cart;
        if (!cart?.items) return;
        const productIds = new Set(cart.items.map((item) => String(item.product_id)));
        this.querySelectorAll('[data-single-per-order="true"]').forEach((row) => {
          row.hidden = productIds.has(String(row.dataset.addonProductId || ''));
        });
      }

      handleClick(event) {
        const stepButton = event.target.closest('[data-addon-step]');
        if (!stepButton || !this.contains(stepButton)) return;
        const input = stepButton.closest('[data-addon-quantity]')?.querySelector('[data-addon-quantity-input]');
        if (!input) return;
        const next = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(stepButton.dataset.addonStep, 10));
        input.value = String(next);
      }

      handleChange(event) {
        const toggle = event.target.closest('input[data-warranty-toggle]');
        if (toggle && this.contains(toggle)) {
          toggle.closest('.paddons__item')?.classList.toggle('paddons__item--opted', toggle.checked);
          return;
        }
        const variant = event.target.closest('select[data-addon-variant]');
        if (!variant || !this.contains(variant)) return;
        const row = variant.closest('.paddons__item');
        const price = row?.querySelector('[data-addon-price]');
        const option = variant.selectedOptions[0];
        if (price && option?.dataset.price) price.textContent = option.dataset.price;
      }

      async handleSubmit(event) {
        const form = event.target.closest('[data-addon-form]');
        if (!form || !this.contains(form)) return;
        event.preventDefault();

        const variant = form.querySelector('[data-addon-variant]');
        const quantityInput = form.querySelector('[data-addon-quantity-input]');
        const button = form.querySelector('.paddons__add');
        const status = form.querySelector('[data-addon-status]');
        const row = form.closest('[data-addon-product-id]');
        const productId = row?.dataset.addonProductId || '';
        const singlePerOrder = row?.dataset.singlePerOrder === 'true';
        const variantId = parseInt(variant?.value || '', 10);
        const quantity = singlePerOrder ? 1 : Math.max(1, parseInt(quantityInput?.value || '1', 10) || 1);
        if (!variantId || !button || button.disabled) return;

        if (singlePerOrder && document.querySelector(`[data-cart-line][data-product-id="${productId}"]`)) {
          if (row) row.hidden = true;
          return;
        }

        form.classList.add('is-loading');
        button.disabled = true;
        button.textContent = button.dataset.labelLoading || 'Adding…';
        if (status) status.textContent = '';
        try {
          if (!window.cartStore) throw new Error('Cart is unavailable.');
          const item = { id: variantId, quantity };
          if (singlePerOrder) item.properties = { _single_order_addon: '1' };
          await window.cartStore.add({ items: [item], openDrawer: true });
          button.textContent = button.dataset.labelAdded || 'Added';
          if (status) status.textContent = 'Added to cart.';
          if (quantityInput) quantityInput.value = '1';
          if (singlePerOrder && row) row.hidden = true;
          window.setTimeout(() => {
            button.textContent = button.dataset.labelDefault || 'Add';
            button.disabled = false;
          }, 1400);
        } catch (error) {
          button.textContent = button.dataset.labelError || 'Try again';
          if (status) status.textContent = error instanceof Error ? error.message : 'Could not add this item.';
          window.setTimeout(() => {
            button.textContent = button.dataset.labelDefault || 'Add';
            button.disabled = false;
          }, 1800);
        } finally {
          form.classList.remove('is-loading');
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-panels"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function bindPanelSlider(panel) {
      if (panel.dataset.sliderBound) return;
      panel.dataset.sliderBound = '1';

      var viewport = panel.querySelector('[data-panel-viewport]');
      var prev = panel.querySelector('[data-panel-prev]');
      var next = panel.querySelector('[data-panel-next]');
      if (!viewport) return;

      function update() {
        var max = viewport.scrollWidth - viewport.clientWidth;
        var canSlide = max > 4;
        if (prev) { prev.hidden = !canSlide; prev.disabled = viewport.scrollLeft <= 2; }
        if (next) { next.hidden = !canSlide; next.disabled = viewport.scrollLeft >= max - 2; }
      }

      if (prev) prev.addEventListener('click', function() { viewport.scrollBy({ left: -viewport.clientWidth, behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function() { viewport.scrollBy({ left: viewport.clientWidth, behavior: 'smooth' }); });
      viewport.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
      panel.__ppanelsUpdate = update;
    }

    function chunkIntoSlides(cardsHtml) {
      var slides = [];
      for (var i = 0; i < cardsHtml.length; i += 4) {
        slides.push('<div class="ppanels__grid">' + cardsHtml.slice(i, i + 4).join('') + '</div>');
      }
      return slides;
    }

    /* Admin-chosen sort order (best selling / price / alphabetical) re-fetches
       the collection through the lean `card` view so Shopify applies sort_by
       server-side. The server-rendered collection-order grid stays as the
       no-JS / fetch-failure fallback. */
    function applyPanelSort(panel) {
      var sort = panel.dataset.panelSort;
      var url = panel.dataset.panelCollectionUrl;
      if (!sort || !url) return;
      var sep = url.indexOf('?') > -1 ? '&' : '?';
      fetch(url + sep + 'view=card&sort_by=' + encodeURIComponent(sort))
        .then(function(response) { return response.ok ? response.text() : ''; })
        .then(function(html) {
          if (!html || !html.trim()) return;
          var probe = document.createElement('div');
          probe.innerHTML = html;
          var cards = Array.prototype.map.call(probe.children, function(el) { return el.outerHTML; });
          if (!cards.length) return;
          var track = panel.querySelector('[data-panel-track]');
          if (!track) return;
          track.innerHTML = chunkIntoSlides(cards).join('');
          if (window.initProductCards) window.initProductCards(track);
          if (panel.__ppanelsUpdate) panel.__ppanelsUpdate();
        })
        .catch(function() { /* keep the server-rendered fallback */ });
    }

    function bootPanels(root) {
      if (!root || root.dataset.bound) return;
      root.dataset.bound = '1';

      var designMode = root.hasAttribute('data-design-mode');
      root.querySelectorAll('[data-ppanels-panel]').forEach(bindPanelSlider);
      if (!designMode) root.querySelectorAll('[data-panel-sort]').forEach(applyPanelSort);

      var recentPanels = root.querySelectorAll('[data-ppanels-recent]');
      if (!recentPanels.length || designMode) return;

      var recent = window.nerdioGetRecent ? window.nerdioGetRecent() : [];
      var usable = recent.filter(function(item) { return item && item.handle; }).slice(0, 8);

      function dropPanels() {
        recentPanels.forEach(function(panel) { panel.remove(); });
      }

      if (!usable.length) { dropPanels(); return; }

      Promise.all(usable.map(function(item) {
        var base = item.url || ('/products/' + encodeURIComponent(item.handle));
        var sep = base.indexOf('?') > -1 ? '&' : '?';
        return fetch(base + sep + 'view=card')
          .then(function(response) { return response.ok ? response.text() : ''; })
          .catch(function() { return ''; });
      })).then(function(cards) {
        var usableCards = cards.filter(function(card) { return card && card.trim(); });
        if (!usableCards.length) { dropPanels(); return; }
        var slides = [];
        for (var i = 0; i < usableCards.length; i += 4) {
          slides.push('<div class="ppanels__grid">' + usableCards.slice(i, i + 4).join('') + '</div>');
        }
        recentPanels.forEach(function(panel) {
          var track = panel.querySelector('[data-panel-track]');
          if (track) track.innerHTML = slides.join('');
          panel.hidden = false;
          if (window.initProductCards && track) window.initProductCards(track);
          if (panel.__ppanelsUpdate) panel.__ppanelsUpdate();
        });
        root.hidden = false;
      });
    }

    function bootAllPanels() {
      document.querySelectorAll('[data-ppanels]').forEach(bootPanels);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootAllPanels);
    else bootAllPanels();
    document.addEventListener('shopify:section:load', bootAllPanels);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-related"] && !Shopify.designMode) return;
  try {
    
  function initProductRelated(root) {
    if (root.dataset.bound) return;
    root.dataset.bound = '1';

    const section = root.closest('section');
    const tabs = Array.from(section.querySelectorAll('[data-prel-tab]'));
    const heading = section.querySelector('[data-prel-heading]');
    const limit = parseInt(root.dataset.limit, 10) || 4;
    const productId = root.dataset.productId;
    const productHandle = root.dataset.productHandle;
    const recUrl = root.dataset.recUrl;
    const sectionId = root.dataset.sectionId;

    function panel(name) { return root.querySelector('[data-prel-panel="' + name + '"]'); }

    function showTab(name) {
      tabs.forEach(t => {
        const active = t.dataset.prelTab === name;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
        if (active && heading) heading.textContent = t.textContent.trim();
      });
      root.querySelectorAll('[data-prel-panel]').forEach(p => {
        p.classList.toggle('is-active', p.dataset.prelPanel === name);
      });
      const p = panel(name);
      if (p && p.dataset.loaded !== 'true') loadPanel(name, p);
    }

    function loadPanel(name, p) {
      if (name === 'related' || name === 'complementary') {
        const url = recUrl + '?section_id=' + encodeURIComponent(sectionId) +
                    '&product_id=' + encodeURIComponent(productId) +
                    '&limit=' + limit + '&intent=' + name;
        fetch(url)
          .then(r => r.text())
          .then(html => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const fresh = doc.querySelector('[data-prel-panel="' + name + '"]') ||
                          doc.querySelector('.prel__grid');
            if (fresh && fresh.children.length > 0 && !fresh.querySelector('.prel__skeleton')) {
              p.innerHTML = fresh.innerHTML;
              if (window.initProductCards) window.initProductCards(p);
            } else {
              p.innerHTML = '<div class="empty-state prel__empty" role="status">' +
                '<svg class="empty-state__icon" viewBox="0 0 48 48" width="44" height="44" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M24 6v8M24 34v8M6 24h8M34 24h8M11 11l5.7 5.7M31.3 31.3 37 37M11 37l5.7-5.7M31.3 16.7 37 11"/><circle cx="24" cy="24" r="4"/></svg>' +
                '<h3 class="empty-state__heading">No recommendations yet</h3>' +
                '<p class="empty-state__text">Check back as we add more products.</p>' +
                '<a href="' + (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'collections/all" class="empty-state__cta">Browse all products</a>' +
              '</div>';
            }
            p.dataset.loaded = 'true';
          })
          .catch(() => {
            p.innerHTML = '<div class="empty-state prel__empty" role="status">' +
              '<svg class="empty-state__icon" viewBox="0 0 48 48" width="44" height="44" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="24" cy="24" r="16"/><path d="M24 16v10M24 32h.01"/></svg>' +
              '<h3 class="empty-state__heading">Could not load recommendations</h3>' +
              '<p class="empty-state__text">Try refreshing the page.</p>' +
            '</div>';
            p.dataset.loaded = 'true';
          });
        return;
      }
      if (name === 'recent') {
        const list = (window.nerdioGetRecent && window.nerdioGetRecent()) || [];
        const items = list.filter(r => r.handle && r.handle !== productHandle).slice(0, limit);
        if (!items.length) {
          p.innerHTML = '<div class="empty-state prel__empty" role="status">' +
            '<svg class="empty-state__icon" viewBox="0 0 48 48" width="44" height="44" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="24" cy="24" r="16"/><path d="M24 14v10l7 4"/></svg>' +
            '<h3 class="empty-state__heading">Nothing here yet</h3>' +
            '<p class="empty-state__text">Browse a few products and they\'ll show up here.</p>' +
            '<a href="/collections/all" class="empty-state__cta">Start browsing</a>' +
          '</div>';
          p.dataset.loaded = 'true';
          return;
        }
        Promise.all(items.map(r =>
          fetch('/products/' + r.handle + '?view=card')
            .then(res => res.ok ? res.text() : '')
            .catch(() => '')
        )).then(htmls => {
          const joined = htmls.filter(h => h && h.trim()).join('');
          if (joined) {
            p.innerHTML = joined;
            if (window.initProductCards) window.initProductCards(p);
          } else {
            p.innerHTML = '<div class="empty-state prel__empty" role="status">' +
              '<svg class="empty-state__icon" viewBox="0 0 48 48" width="44" height="44" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="24" cy="24" r="16"/><path d="M24 16v10M24 32h.01"/></svg>' +
              '<h3 class="empty-state__heading">Could not load recently viewed</h3>' +
            '</div>';
          }
          p.dataset.loaded = 'true';
        });
      }
    }

    tabs.forEach(t => t.addEventListener('click', () => showTab(t.dataset.prelTab)));

    const active = root.querySelector('[data-prel-panel].is-active');
    if (active && active.dataset.loaded !== 'true') loadPanel(active.dataset.prelPanel, active);
  }

  function bootProductRelated() {
    document.querySelectorAll('[data-prel-root]').forEach(initProductRelated);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootProductRelated);
  } else {
    bootProductRelated();
  }
  document.addEventListener('shopify:section:load', bootProductRelated);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-popup"]) return;
  try {
    
  (function() {
    var popup = document.querySelector('[data-search-popup]');
    if (!popup || popup.dataset.bound) return;
    popup.dataset.bound = '1';

    var form = popup.querySelector('[data-search-form]');
    var input = popup.querySelector('[data-search-input]');
    var defaultEl = popup.querySelector('[data-search-default]');
    var predictiveEl = popup.querySelector('[data-search-predictive]');
    var recentSection = popup.querySelector('[data-recent-section]');
    var recentList = popup.querySelector('[data-recent-list]');
    var clearBtn = popup.querySelector('[data-clear-recent]');

    var predictiveEnabled = popup.getAttribute('data-predictive') === 'true';
    var recentEnabled = popup.getAttribute('data-recent') === 'true';
    var predictiveUrl = popup.getAttribute('data-predictive-url');
    var searchUrl = popup.getAttribute('data-search-url');
    var productLimit = parseInt(popup.getAttribute('data-product-limit'), 10) || 6;
    var showCollections = popup.getAttribute('data-show-collections') === 'true';
    var showPages = popup.getAttribute('data-show-pages') === 'true';

    var STORAGE_KEY = 'nerdio:recent-searches';
    var MAX_RECENT = 6;
    var debounceTimer = null;
    var activeRequest = null;
    var currentQuery = '';

    function open() {
      try { popup.showModal(); } catch (e) { popup.setAttribute('open', ''); }
      renderRecent();
      setTimeout(function() { input.focus(); }, 50);
    }

    function close() {
      try { popup.close(); } catch (e) { popup.removeAttribute('open'); }
      input.value = '';
      showDefault();
    }

    function showDefault() {
      if (predictiveEl) { predictiveEl.setAttribute('hidden', ''); predictiveEl.innerHTML = ''; }
      if (defaultEl) defaultEl.removeAttribute('hidden');
    }

    function showPredictive() {
      if (defaultEl) defaultEl.setAttribute('hidden', '');
      if (predictiveEl) predictiveEl.removeAttribute('hidden');
    }

    /* ── Recent searches ── */
    function getRecent() {
      if (!recentEnabled) return [];
      try {
        var raw = localStorage.getItem(STORAGE_KEY);
        return raw ? JSON.parse(raw) : [];
      } catch (e) { return []; }
    }

    function saveRecent(term) {
      if (!recentEnabled || !term) return;
      var list = getRecent().filter(function(t) { return t.toLowerCase() !== term.toLowerCase(); });
      list.unshift(term);
      if (list.length > MAX_RECENT) list = list.slice(0, MAX_RECENT);
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); } catch (e) {}
    }

    function renderRecent() {
      if (!recentSection || !recentList) return;
      var list = getRecent();
      if (!list.length) {
        recentSection.setAttribute('hidden', '');
        return;
      }
      recentSection.removeAttribute('hidden');
      recentList.innerHTML = list.map(function(term) {
        var safe = escapeHtml(term);
        return '<a href="' + searchUrl + '?q=' + encodeURIComponent(term) + '&type=product,collection,article,page" class="search-popup__chip">' + safe + '</a>';
      }).join('');
    }

    if (clearBtn) {
      clearBtn.addEventListener('click', function() {
        try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
        renderRecent();
      });
    }

    /* ── Predictive search ── */
    function escapeHtml(str) {
      return String(str).replace(/[&<>"']/g, function(c) {
        return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
      });
    }

    function highlight(text, query) {
      if (!query) return escapeHtml(text);
      var safe = escapeHtml(text);
      var q = escapeHtml(query).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      return safe.replace(new RegExp('(' + q + ')', 'ig'), '<mark>$1</mark>');
    }

    function fetchPredictive(query) {
      if (activeRequest) activeRequest.abort();
      var controller = new AbortController();
      activeRequest = controller;

      var types = ['product'];
      if (showCollections) types.push('collection');
      if (showPages) types.push('page', 'article');

      var url = predictiveUrl +
        '?q=' + encodeURIComponent(query) +
        '&resources[type]=' + types.join(',') +
        '&resources[limit]=' + productLimit +
        '&resources[limit_scope]=each' +
        '&resources[options][fields]=title,product_type,variants.title,variants.sku,tag,body' +
        '&resources[options][unavailable_products]=last';

      predictiveEl.innerHTML = '<div class="search-popup__loading">Searching…</div>';
      showPredictive();

      fetch(url, { signal: controller.signal, headers: { 'Accept': 'application/json' } })
        .then(function(r) { return r.json(); })
        .then(function(data) {
          if (query !== currentQuery) return;
          renderPredictive(data, query);
        })
        .catch(function(err) {
          if (err.name === 'AbortError') return;
          predictiveEl.innerHTML = '<div class="search-popup__empty">Something went wrong. Try again.</div>';
        });
    }

    function renderPredictive(data, query) {
      var results = (data && data.resources && data.resources.results) || {};
      var products = results.products || [];
      var collections = results.collections || [];
      var pages = results.pages || [];
      var articles = results.articles || [];
      var otherLinks = collections.concat(pages).concat(articles);

      if (!products.length && !otherLinks.length) {
        predictiveEl.innerHTML = '<div class="search-popup__empty">No results for "' + escapeHtml(query) + '". Press Enter to search anyway.</div>';
        return;
      }

      var viewAllUrl = searchUrl + '?q=' + encodeURIComponent(query) + '&type=product,collection,article,page';

      var html = '';

      /* Products column */
      html += '<div class="search-popup__results-col">';
      if (products.length) {
        html += '<div class="search-popup__results-group">';
        html += '<h4>Products</h4>';
        html += '<div class="search-popup__products">';
        products.forEach(function(p) {
          var img = p.image || (p.featured_image && p.featured_image.url) || '';
          var price = p.price ? formatMoney(p.price) : '';
          html += '<a href="' + p.url + '" class="search-popup__product search-popup__result-link">';
          html += '<div class="search-popup__product-img">';
          if (img) html += '<img src="' + img + '" alt="" loading="lazy">';
          html += '</div>';
          html += '<div class="search-popup__product-meta">';
          html += '<div class="search-popup__product-title">' + highlight(p.title, query) + '</div>';
          if (price) html += '<div class="search-popup__product-price">' + price + '</div>';
          html += '</div>';
          html += '</a>';
        });
        html += '</div>';
        html += '<a href="' + viewAllUrl + '" class="search-popup__view-all">View all results →</a>';
        html += '</div>';
      }
      html += '</div>';

      /* Collections / pages column — only render when non-empty */
      var hasSide = collections.length || pages.length || articles.length;
      if (hasSide) {
        html += '<div class="search-popup__results-col">';
        if (collections.length) {
          html += '<div class="search-popup__results-group"><h4>Collections</h4><div class="search-popup__results-list">';
          collections.forEach(function(c) {
            html += '<a href="' + c.url + '" class="search-popup__result-link"><span class="search-popup__result-title">' + highlight(c.title, query) + '</span></a>';
          });
          html += '</div></div>';
        }
        if (pages.length || articles.length) {
          html += '<div class="search-popup__results-group"><h4>Pages &amp; articles</h4><div class="search-popup__results-list">';
          pages.concat(articles).forEach(function(p) {
            html += '<a href="' + p.url + '" class="search-popup__result-link"><span class="search-popup__result-title">' + highlight(p.title, query) + '</span></a>';
          });
          html += '</div></div>';
        }
        html += '</div>';
      }

      predictiveEl.classList.toggle('has-side', !!hasSide);
      predictiveEl.innerHTML = html;
    }

    function formatMoney(cents) {
      if (typeof cents === 'string') return cents;
      try {
        return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' });
      } catch (e) {
        return '$' + (cents / 100).toFixed(2);
      }
    }

    /* ── Event wiring ── */
    if (predictiveEnabled && input && predictiveEl) {
      input.addEventListener('input', function() {
        var q = input.value.trim();
        currentQuery = q;
        clearTimeout(debounceTimer);
        if (q.length < 2) { showDefault(); return; }
        debounceTimer = setTimeout(function() { fetchPredictive(q); }, 150);
      });
    }

    if (form) {
      form.addEventListener('submit', function() {
        var q = input.value.trim();
        if (q) saveRecent(q);
      });
    }

    /* Keyboard nav through predictive results */
    input.addEventListener('keydown', function(e) {
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      if (!predictiveEl || predictiveEl.hasAttribute('hidden')) return;
      var items = predictiveEl.querySelectorAll('.search-popup__result-link');
      if (!items.length) return;
      e.preventDefault();
      var current = predictiveEl.querySelector('.is-active');
      var idx = current ? Array.prototype.indexOf.call(items, current) : -1;
      if (e.key === 'ArrowDown') idx = (idx + 1) % items.length;
      else idx = (idx - 1 + items.length) % items.length;
      items.forEach(function(el) { el.classList.remove('is-active'); });
      items[idx].classList.add('is-active');
      items[idx].scrollIntoView({ block: 'nearest' });
    });

    input.addEventListener('keydown', function(e) {
      if (e.key !== 'Enter') return;
      var active = predictiveEl && predictiveEl.querySelector('.is-active');
      if (active) {
        e.preventDefault();
        var q = input.value.trim();
        if (q) saveRecent(q);
        window.location.href = active.getAttribute('href');
      }
    });

    /* Open / close triggers */
    document.addEventListener('click', function(e) {
      var trigger = e.target.closest('[data-search-open]');
      if (trigger) { e.preventDefault(); open(); return; }
      if (e.target.closest('[data-close]') && popup.open) { close(); }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === '/' && !['INPUT', 'TEXTAREA'].includes(document.activeElement.tagName)) {
        e.preventDefault();
        open();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
